import React from 'react';
import PropTypes from 'prop-types';
import './coderimg.css';
export default function Codering(props) {
  const theme = props.theme;
  return (
    <div>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="140 80 460 370"
        style={{ enableBackground: 'new 0 0 566.6 553' }}>
        <rect x="149.7" y="116.6" className="st0" width="79" height="96" />

        <g id="Screens">
          <rect x="395" y="103" className="st4" width="140.1" height="114.2" />
          <rect x="385.1" y="110.3" className="st5" width="140.1" height="114.2" />
          <rect x="371.4" y="118.2" className="st6" width="143.9" height="117.2" />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M515.2,235.4c0,0,0-0.8,0-2.2s0-3.5,0-6.3c0-5.5,0-13.5,0-23.8c0-20.5-0.1-49.7-0.1-85l0.2,0.2H371.4l0,0
		l0.3-0.3c0,42.4,0,82.4,0,117.2l-0.2-0.2l104,0.1l29.4,0.1h7.8h2h0.7h-2.6h-7.8l-29.4,0.1l-104.1,0.1h-0.2v-0.2
		c0-34.8,0-74.8,0-117.2v-0.3h0.3h143.9h0.2v0.2c0,35.4-0.1,64.7-0.1,85.2c0,10.2,0,18.2-0.1,23.7c0,2.7,0,4.8,0,6.2
		S515.2,235.4,515.2,235.4z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M388.9,135.1l-1.5,0.6l1.5,0.6v0.6l-2.2-0.8v-0.6l2.2-0.8V135.1z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M392.5,134.1v3.2h-0.8V136h-1.5v1.3h-0.8v-3.2h0.8v1.3h1.5v-1.3H392.5z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M394,134.7h-1v-0.6h2.8v0.6h-1v2.6H394V134.7z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M399.1,137.3v-2l-1,1.6h-0.3l-1-1.6v1.9h-0.7V134h0.6l1.2,2l1.2-2h0.6v3.2L399.1,137.3z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M400.6,134.1h0.8v2.6h1.7v0.6h-2.4L400.6,134.1z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M405.5,135.4v0.6l-2.2,0.8v-0.6l1.5-0.6l-1.5-0.6v-0.5L405.5,135.4z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M387.6,224l-1.6,0.6l1.5,0.6v0.6l-2.2-0.8v-0.6l2.2-0.8L387.6,224z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M389.2,222.3h0.6l-1.5,4.4h-0.6L389.2,222.3z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M393,223v3.2h-0.8v-1.3h-1.4v1.3h-0.8V223h0.8v1.3h1.5V223H393z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M394.5,223.6h-1V223h2.8v0.6h-1v2.6h-0.8L394.5,223.6z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M399.6,226.2v-2l-1,1.6h-0.3l-1-1.6v1.9h-0.7V223h0.6l1.2,2l1.2-2h0.6v3.2L399.6,226.2z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M401.1,223h0.8v2.6h1.6v0.6h-2.4V223z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M406,224.3v0.6l-2.2,0.8v-0.6l1.5-0.6l-1.5-0.6v-0.6L406,224.3z"
          />
          <path d="M399.1,144l-1.6,0.6l1.6,0.6v0.4l-2.1-0.8v-0.4l2.1-0.8V144z" />
          <path d="M402.7,143v3.2h-0.5v-1.4h-1.9v1.4h-0.5V143h0.5v1.4h1.9V143H402.7z" />
          <path d="M406,145.9v0.4h-2.4V143h2.3v0.4h-1.8v1h1.6v0.4h-1.6v1L406,145.9z" />
          <path d="M408.8,145.5h-1.7l-0.4,0.8h-0.5l1.5-3.2h0.5l1.5,3.2h-0.5L408.8,145.5z M408.6,145.1l-0.7-1.6l-0.7,1.6H408.6z" />
          <path
            d="M410.1,143h1.4c0.9-0.1,1.7,0.6,1.8,1.5c0.1,0.9-0.6,1.7-1.5,1.8c-0.1,0-0.2,0-0.3,0h-1.4V143z M411.5,145.9
		c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2l0,0h-0.9v2.4H411.5z"
          />
          <path d="M415.9,144.5v0.4l-2.1,0.8v-0.4l1.6-0.6l-1.6-0.6v-0.4L415.9,144.5z" />
          <path d="M399.1,155.1l-1.6,0.6l1.6,0.6v0.4L397,156v-0.4l2.1-0.8V155.1z" />
          <path d="M400.5,154.6h-1.1v-0.4h2.7v0.4H401v2.9h-0.5L400.5,154.6z" />
          <path d="M402.6,154.2h0.5v3.2h-0.5V154.2z" />
          <path d="M404.7,154.6h-1.1v-0.4h2.7v0.4h-1.1v2.9h-0.5L404.7,154.6z" />
          <path d="M406.7,154.2h0.5v2.8h1.8v0.4h-2.2L406.7,154.2z" />
          <path d="M411.9,157v0.4h-2.4v-3.2h2.3v0.4H410v1h1.6v0.4H410v1L411.9,157z" />
          <path d="M414.5,155.6v0.4l-2.1,0.8v-0.4l1.6-0.6l-1.6-0.6v-0.4L414.5,155.6z" />
          <path d="M416.5,154.2h0.5v2.8h1.8v0.4h-2.2V154.2z" />
          <path
            d="M419,156.2c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3c0,0,0,0,0,0c-0.7,0-1.2-0.5-1.3-1.2
		C419,156.2,419,156.2,419,156.2z M421.1,156.2c0.1-0.5-0.3-0.9-0.7-0.9c-0.5-0.1-0.9,0.3-0.9,0.7c0,0.1,0,0.1,0,0.2
		c-0.1,0.5,0.3,0.9,0.7,0.9c0.5,0.1,0.9-0.3,0.9-0.7C421.1,156.3,421.1,156.2,421.1,156.2z"
          />
          <path
            d="M423.5,154.9v0.4h-0.1c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0.1,0,0.1v1.2h-0.4V155h0.4v0.4C422.8,155.1,423.1,154.9,423.5,154.9z
		"
          />
          <path
            d="M426.2,156.3h-2c0.1,0.4,0.4,0.8,0.9,0.7c0.3,0,0.5-0.1,0.7-0.3l0.2,0.3c-0.5,0.5-1.4,0.5-1.9,0c-0.2-0.2-0.4-0.5-0.4-0.9
		c0-0.7,0.5-1.2,1.2-1.2c0,0,0,0,0.1,0c0.7,0,1.2,0.5,1.2,1.1c0,0,0,0.1,0,0.1C426.2,156.2,426.2,156.3,426.2,156.3z M424.2,156h1.6
		c0-0.4-0.4-0.8-0.8-0.8C424.6,155.2,424.2,155.6,424.2,156z"
          />
          <path
            d="M430.9,156v1.4h-0.5V156c0-0.5-0.2-0.7-0.6-0.7c-0.4,0-0.7,0.3-0.7,0.7c0,0,0,0.1,0,0.1v1.3h-0.5V156
		c0-0.5-0.2-0.7-0.6-0.7c-0.4,0-0.7,0.3-0.7,0.7c0,0,0,0.1,0,0.1v1.3h-0.4v-2.5h0.4v0.4c0.2-0.3,0.5-0.4,0.9-0.4
		c0.3,0,0.7,0.1,0.9,0.4c0.2-0.3,0.6-0.5,0.9-0.4c0.5,0,1,0.3,1,0.9C430.9,155.9,430.9,155.9,430.9,156z"
          />
          <path
            d="M432.9,154.2c0-0.2,0.1-0.3,0.3-0.3c0,0,0,0,0,0c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0c0,0.2-0.1,0.3-0.3,0.3c0,0,0,0,0,0
		C433,154.5,432.9,154.4,432.9,154.2C432.9,154.2,432.9,154.2,432.9,154.2z M433,154.9h0.5v2.5H433L433,154.9z"
          />
          <path
            d="M436.8,156.2c0,0.7-0.5,1.2-1.1,1.3c0,0-0.1,0-0.1,0c-0.3,0-0.7-0.1-0.9-0.4v1.3h-0.5v-3.4h0.4v0.4
		c0.2-0.3,0.5-0.4,0.9-0.4c0.7,0,1.2,0.5,1.2,1.1C436.8,156.1,436.8,156.1,436.8,156.2z M436.4,156.2c0-0.5-0.4-0.8-0.8-0.8
		c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8C436,157,436.4,156.6,436.4,156.2z"
          />
          <path
            d="M437.1,157.1l0.2-0.4c0.3,0.2,0.6,0.2,0.9,0.2c0.4,0,0.6-0.1,0.6-0.3c0-0.6-1.6-0.1-1.6-1.1c0-0.4,0.4-0.7,1-0.7
		c0.3,0,0.6,0.1,0.9,0.2l-0.2,0.4c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.6,0.1-0.6,0.3c0,0.6,1.6,0.1,1.6,1.1c0,0.4-0.4,0.7-1.1,0.7
		C437.7,157.4,437.4,157.3,437.1,157.1z"
          />
          <path
            d="M442,154.9v2.5h-0.4V157c-0.2,0.3-0.5,0.4-0.8,0.4c-0.6,0-1-0.4-1.1-0.9c0,0,0-0.1,0-0.1v-1.4h0.5v1.4
		c0,0.5,0.2,0.7,0.7,0.7c0.4,0,0.7-0.3,0.8-0.7c0,0,0-0.1,0-0.1v-1.3L442,154.9z"
          />
          <path
            d="M447,156v1.4h-0.4V156c0-0.5-0.2-0.7-0.6-0.7c-0.4,0-0.7,0.3-0.7,0.7c0,0,0,0.1,0,0.1v1.3h-0.5V156c0-0.5-0.2-0.7-0.6-0.7
		c-0.4,0-0.7,0.3-0.7,0.7c0,0,0,0.1,0,0.1v1.3h-0.5v-2.5h0.4v0.4c0.2-0.3,0.5-0.4,0.9-0.4c0.3,0,0.7,0.1,0.9,0.4
		c0.2-0.3,0.6-0.5,1-0.4c0.5,0,1,0.3,1,0.8C447,155.8,447,155.9,447,156z"
          />
          <path d="M451,155.1l-1.6,0.6l1.6,0.6v0.4l-2.1-0.8v-0.4l2.1-0.8V155.1z" />
          <path d="M452.7,153.5h0.4l-1.5,4.4h-0.4L452.7,153.5z" />
          <path d="M454.2,154.6h-1.1v-0.4h2.7v0.4h-1.1v2.9h-0.5L454.2,154.6z" />
          <path d="M456.3,154.2h0.5v3.2h-0.5V154.2z" />
          <path d="M458.4,154.6h-1.1v-0.4h2.7v0.4h-1.1v2.9h-0.5L458.4,154.6z" />
          <path d="M460.4,154.2h0.5v2.8h1.8v0.4h-2.2V154.2z" />
          <path d="M465.5,157v0.4h-2.4v-3.2h2.3v0.4h-1.8v1h1.6v0.4h-1.6v1L465.5,157z" />
          <path d="M468.2,155.6v0.4l-2.1,0.8v-0.4l1.6-0.6l-1.6-0.6v-0.4L468.2,155.6z" />
          <path d="M399.1,166.3l-1.6,0.6l1.6,0.6v0.4l-2.1-0.8v-0.4l2.1-0.8V166.3z" />
          <path d="M400.8,164.6h0.4l-1.5,4.4h-0.4L400.8,164.6z" />
          <path d="M404.3,165.3v3.2h-0.5v-1.4H402v1.4h-0.5v-3.2h0.5v1.4h1.9v-1.4H404.3z" />
          <path d="M407.6,168.1v0.4h-2.4v-3.2h2.3v0.4h-1.8v1h1.6v0.4h-1.6v1L407.6,168.1z" />
          <path d="M410.4,167.7h-1.7l-0.4,0.8h-0.5l1.5-3.2h0.5l1.5,3.2h-0.5L410.4,167.7z M410.3,167.4l-0.7-1.6l-0.7,1.6H410.3z" />
          <path
            d="M411.8,165.3h1.4c0.9-0.1,1.7,0.6,1.8,1.5c0.1,0.9-0.6,1.7-1.5,1.8c-0.1,0-0.2,0-0.3,0h-1.4V165.3z M413.1,168.1
		c0.7,0.1,1.3-0.4,1.3-1.1s-0.4-1.3-1.1-1.3c-0.1,0-0.1,0-0.2,0h-0.9v2.4H413.1z"
          />
          <path d="M417.5,166.7v0.4l-2.1,0.8v-0.3l1.6-0.6l-1.6-0.6v-0.4L417.5,166.7z" />
          <path d="M390.5,175.9l-1.6,0.6l1.6,0.6v0.4l-2.1-0.8v-0.4l2.1-0.8V175.9z" />
          <path
            d="M394,177.3c0,0.6-0.4,0.9-1.2,0.9h-1.5v-3.2h1.5c0.8,0,1.2,0.3,1.2,0.8c-0.4,0.2-0.6,0.7-0.3,1.1
		C393.6,177.1,393.8,177.2,394,177.3L394,177.3z M391.7,175.3v1h1c0.5,0,0.7-0.2,0.7-0.5s-0.3-0.5-0.7-0.5L391.7,175.3z
		 M393.5,177.3c0-0.4-0.3-0.6-0.8-0.6h-1.1v1.1h1.1C393.3,177.8,393.6,177.6,393.5,177.3L393.5,177.3z"
          />
          <path
            d="M394.5,176.6c0-1,0.7-1.8,1.7-1.8c1,0,1.8,0.7,1.8,1.7c0,1-0.7,1.8-1.7,1.8c0,0,0,0-0.1,0
		C395.3,178.3,394.5,177.6,394.5,176.6C394.5,176.7,394.5,176.6,394.5,176.6z M397.5,176.6c0-0.7-0.5-1.3-1.2-1.3s-1.3,0.5-1.3,1.2
		c0,0.7,0.5,1.3,1.2,1.3c0,0,0,0,0,0C396.9,177.8,397.5,177.3,397.5,176.6C397.5,176.6,397.5,176.6,397.5,176.6L397.5,176.6z"
          />
          <path
            d="M398.7,174.9h1.4c0.9-0.1,1.7,0.6,1.8,1.5c0.1,0.9-0.6,1.7-1.5,1.8c-0.1,0-0.2,0-0.3,0h-1.4L398.7,174.9z M400,177.8
		c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2h-0.9v2.4H400z"
          />
          <path d="M403.6,177.1v1.1h-0.5V177l-1.3-2.1h0.5l1,1.7l1-1.7h0.5L403.6,177.1z" />
          <path d="M407.2,176.4v0.4l-2.1,0.8v-0.4l1.6-0.6l-1.6-0.6v-0.3L407.2,176.4z" />
          <path d="M390.5,187l-1.6,0.6l1.6,0.6v0.4l-2.1-0.8v-0.4l2.1-0.8V187z" />
          <path d="M394,186.1v3.2h-0.5v-1.4h-1.9v1.4h-0.5v-3.2h0.5v1.4h1.9v-1.4H394z" />
          <path d="M395.8,186.1v3.2h-0.5v-2.8h-0.7v-0.4L395.8,186.1z" />
          <path d="M398.6,187.5v0.4l-2.1,0.8v-0.4l1.6-0.6l-1.6-0.6v-0.4L398.6,187.5z" />
          <path d="M400.7,186.1h0.3v2.9h1.8v0.3h-2.2V186.1z" />
          <path
            d="M403.1,188.1c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2c0,0.7-0.6,1.2-1.2,1.2C403.7,189.4,403.1,188.8,403.1,188.1
		C403.1,188.1,403.1,188.1,403.1,188.1z M405.2,188.1c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9
		C404.8,189,405.2,188.6,405.2,188.1C405.2,188.1,405.2,188.1,405.2,188.1z"
          />
          <path d="M407.5,186.8v0.3h-0.1c-0.4,0-0.8,0.3-0.8,0.8c0,0,0,0.1,0,0.1v1.2h-0.3v-2.4h0.3v0.5C406.7,187,407.1,186.8,407.5,186.8z" />
          <path
            d="M410.2,188.2h-2c0,0.5,0.5,0.9,1,0.9c0,0,0,0,0,0c0.3,0,0.6-0.1,0.8-0.3l0.2,0.2c-0.2,0.3-0.6,0.4-0.9,0.4
		c-0.7,0-1.2-0.5-1.3-1.1c0,0,0-0.1,0-0.1c0-0.7,0.5-1.2,1.1-1.2c0,0,0,0,0.1,0c0.6,0,1.2,0.5,1.2,1.1c0,0,0,0.1,0,0.1L410.2,188.2z
		 M408.2,187.9h1.7c-0.1-0.5-0.5-0.8-1-0.8C408.5,187.2,408.2,187.5,408.2,187.9z"
          />
          <path
            d="M414.9,187.9v1.4h-0.3v-1.4c0-0.5-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0.1,0,0.1v1.3h-0.3v-1.4
		c0-0.5-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.8c0,0,0,0.1,0,0.1v1.3h-0.3v-2.4h0.3v0.4c0.2-0.3,0.5-0.5,0.9-0.5
		c0.4,0,0.7,0.2,0.9,0.5c0.2-0.3,0.6-0.6,1-0.5c0.5,0,0.9,0.4,1,0.9C414.9,187.8,414.9,187.8,414.9,187.9z"
          />
          <path
            d="M416.9,186.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0c0,0.1-0.1,0.2-0.2,0.2S416.9,186.2,416.9,186.1z
		 M417,186.9h0.3v2.4H417L417,186.9z"
          />
          <path
            d="M420.7,188.1c0,0.7-0.5,1.2-1.1,1.2c0,0-0.1,0-0.1,0c-0.4,0-0.7-0.2-0.9-0.5v1.4h-0.3v-3.3h0.3v0.5
		c0.2-0.3,0.6-0.5,0.9-0.5C420.1,186.8,420.7,187.3,420.7,188.1C420.7,188,420.7,188,420.7,188.1z M420.4,188.1
		c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9S420.4,188.6,420.4,188.1L420.4,188.1z"
          />
          <path
            d="M421,189l0.1-0.3c0.3,0.2,0.6,0.3,0.9,0.3c0.5,0,0.6-0.2,0.6-0.4c0-0.6-1.6-0.1-1.6-1.1c0-0.4,0.4-0.7,1-0.7
		c0.3,0,0.6,0.1,0.9,0.2l-0.1,0.3c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.6,0.2-0.6,0.4c0,0.7,1.6,0.2,1.6,1.1c0,0.4-0.4,0.7-1,0.7
		C421.7,189.3,421.3,189.2,421,189z"
          />
          <path
            d="M425.8,186.9v2.4h-0.3v-0.4c-0.2,0.3-0.5,0.5-0.9,0.5c-0.5,0-1-0.4-1-0.9c0-0.1,0-0.1,0-0.2v-1.4h0.3v1.4
		c0,0.5,0.3,0.8,0.7,0.8c0.4,0,0.8-0.3,0.8-0.7c0,0,0-0.1,0-0.1v-1.3H425.8z"
          />
          <path
            d="M430.8,187.9v1.4h-0.3v-1.4c0-0.5-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0.1,0,0.1v1.3h-0.3v-1.4
		c0-0.5-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.8c0,0,0,0.1,0,0.1v1.3h-0.3v-2.4h0.3v0.4c0.2-0.3,0.5-0.5,0.9-0.5
		c0.4,0,0.7,0.2,0.9,0.5c0.2-0.4,0.6-0.6,1-0.5c0.5,0,0.9,0.4,0.9,0.9C430.8,187.8,430.8,187.8,430.8,187.9z"
          />
          <path
            d="M435.1,185.9v3.4h-0.3v-0.5c-0.2,0.3-0.6,0.5-0.9,0.5c-0.7-0.1-1.2-0.7-1.1-1.4c0.1-0.6,0.5-1.1,1.1-1.1
		c0.4,0,0.7,0.2,0.9,0.5v-1.5H435.1z M434.8,188.1c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9
		C434.4,189,434.8,188.6,434.8,188.1C434.8,188.1,434.8,188.1,434.8,188.1z"
          />
          <path
            d="M435.8,188.1c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2s-0.6,1.2-1.2,1.2C436.3,189.4,435.8,188.8,435.8,188.1
		C435.8,188.1,435.8,188.1,435.8,188.1z M437.9,188.1c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9
		C437.5,189,437.9,188.6,437.9,188.1C437.9,188.1,437.9,188.1,437.9,188.1z"
          />
          <path d="M438.9,185.9h0.3v3.4h-0.3V185.9z" />
          <path
            d="M439.9,188.1c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2c0,0.7-0.6,1.2-1.2,1.2C440.5,189.4,439.9,188.8,439.9,188.1
		C439.9,188.1,439.9,188.1,439.9,188.1z M442.1,188.1c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9
		C441.7,189,442.1,188.6,442.1,188.1C442.1,188.1,442.1,188.1,442.1,188.1L442.1,188.1z"
          />
          <path d="M444.3,186.8v0.3h-0.1c-0.4,0-0.8,0.3-0.8,0.8c0,0,0,0.1,0,0.1v1.2h-0.3v-2.4h0.3v0.5C443.6,187,443.9,186.8,444.3,186.8z" />
          <path
            d="M445.8,189l0.1-0.3c0.3,0.2,0.6,0.3,0.9,0.3c0.5,0,0.6-0.2,0.6-0.4c0-0.6-1.6-0.1-1.6-1.1c0-0.4,0.3-0.7,1-0.7
		c0.3,0,0.6,0.1,0.9,0.2l-0.1,0.3c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.6,0.2-0.6,0.4c0,0.7,1.6,0.2,1.6,1.1c0,0.4-0.4,0.7-1,0.7
		C446.5,189.4,446.1,189.2,445.8,189z"
          />
          <path
            d="M448.3,186.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0c0,0.1-0.1,0.2-0.2,0.2S448.3,186.2,448.3,186.1z
		 M448.4,186.9h0.3v2.4h-0.3V186.9z"
          />
          <path
            d="M450.9,189.1c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.7-0.2-0.7-0.6c0,0,0-0.1,0-0.1v-1.5h-0.4v-0.3h0.4v-0.5h0.3v0.5h0.7v0.3
		H450v1.5c0,0.2,0.1,0.4,0.3,0.4c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4-0.1L450.9,189.1z"
          />
          <path
            d="M454.6,187.8v1.5h-0.3v-0.4c-0.2,0.3-0.5,0.4-0.8,0.4c-0.5,0-0.9-0.3-0.9-0.7s0.2-0.7,0.9-0.7h0.8v-0.1
		c0-0.3-0.2-0.6-0.5-0.7c0,0-0.1,0-0.1,0c-0.3,0-0.6,0.1-0.8,0.3l-0.1-0.2c0.3-0.2,0.6-0.3,1-0.3c0.5-0.1,0.9,0.3,1,0.7
		C454.6,187.7,454.6,187.7,454.6,187.8z M454.3,188.6v-0.4h-0.8c-0.5,0-0.6,0.2-0.6,0.4s0.2,0.5,0.6,0.5
		C453.8,189.1,454.1,188.9,454.3,188.6L454.3,188.6z"
          />
          <path
            d="M459.5,187.9v1.4h-0.3v-1.4c0-0.5-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.8c0,0,0,0.1,0,0.1v1.3h-0.3v-1.4
		c0-0.5-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.8c0,0,0,0.1,0,0.1v1.3h-0.3v-2.4h0.3v0.4c0.2-0.3,0.5-0.5,0.9-0.5
		c0.4,0,0.7,0.2,0.9,0.5c0.2-0.4,0.6-0.6,1-0.5c0.5,0,0.9,0.4,1,0.9C459.5,187.8,459.5,187.8,459.5,187.9z"
          />
          <path
            d="M462.5,188.2h-2c0,0.5,0.5,0.9,1,0.9c0,0,0,0,0,0c0.3,0,0.6-0.1,0.8-0.3l0.2,0.2c-0.2,0.3-0.6,0.4-0.9,0.4
		c-0.7,0-1.2-0.5-1.3-1.1c0,0,0-0.1,0-0.1c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2C462.6,188.1,462.5,188.1,462.5,188.2z
		 M460.5,187.9h1.7c-0.1-0.5-0.5-0.8-1-0.8C460.9,187.2,460.6,187.5,460.5,187.9z"
          />
          <path
            d="M464.5,189.1c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.7-0.2-0.7-0.6c0,0,0-0.1,0-0.1v-1.5h-0.4v-0.3h0.4v-0.5h0.3v0.5h0.7v0.3
		h-0.7v1.5c0,0.2,0.1,0.4,0.3,0.4c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4-0.1L464.5,189.1z"
          />
          <path
            d="M465.4,189.1c0,0.1,0,0.2-0.1,0.3l-0.2,0.6h-0.2l0.2-0.7c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2
		C465.3,188.8,465.4,188.9,465.4,189.1C465.4,189.1,465.4,189.1,465.4,189.1z"
          />
          <path
            d="M467.1,188.1c0-0.7,0.5-1.2,1.2-1.2c0,0,0.1,0,0.1,0c0.4,0,0.8,0.2,1,0.5l-0.2,0.2c-0.2-0.2-0.4-0.4-0.7-0.4
		c-0.5,0.2-0.8,0.7-0.6,1.3c0.1,0.3,0.3,0.5,0.6,0.6c0.3,0,0.5-0.1,0.7-0.4l0.2,0.2c-0.2,0.3-0.6,0.5-1,0.5
		C467.7,189.4,467.1,188.8,467.1,188.1C467.1,188.1,467.1,188.1,467.1,188.1z"
          />
          <path
            d="M469.7,188.1c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2c0,0.7-0.6,1.2-1.2,1.2C470.2,189.4,469.7,188.8,469.7,188.1
		C469.7,188.1,469.7,188.1,469.7,188.1z M471.8,188.1c0.1-0.5-0.3-0.9-0.8-1c0,0-0.1,0-0.1,0c-0.5,0.2-0.8,0.7-0.6,1.3
		c0.1,0.3,0.3,0.5,0.6,0.6C471.4,189,471.8,188.6,471.8,188.1C471.8,188.1,471.8,188.1,471.8,188.1z"
          />
          <path
            d="M475.1,187.9v1.4h-0.3v-1.4c0.1-0.4-0.2-0.7-0.6-0.8c-0.1,0-0.1,0-0.2,0c-0.4,0-0.8,0.3-0.9,0.7c0,0,0,0.1,0,0.1v1.3h-0.3
		v-2.4h0.3v0.4c0.2-0.3,0.6-0.5,0.9-0.5c0.5,0,1,0.4,1,0.9C475.1,187.8,475.1,187.8,475.1,187.9z"
          />
          <path
            d="M475.6,189l0.1-0.3c0.3,0.2,0.6,0.3,0.9,0.3c0.5,0,0.6-0.2,0.6-0.4c0-0.6-1.6-0.1-1.6-1.1c0-0.4,0.3-0.7,1-0.7
		c0.3,0,0.6,0.1,0.9,0.2l-0.1,0.3c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.6,0.2-0.6,0.4c0,0.7,1.6,0.2,1.6,1.1c0,0.4-0.4,0.7-1,0.7
		C476.3,189.4,475.9,189.2,475.6,189z"
          />
          <path
            d="M480.3,188.2h-2c0,0.5,0.5,0.9,1,0.9c0,0,0,0,0,0c0.3,0,0.6-0.1,0.8-0.3l0.2,0.2c-0.2,0.3-0.6,0.4-0.9,0.4
		c-0.7,0-1.2-0.5-1.3-1.1c0,0,0-0.1,0-0.1c0-0.7,0.5-1.2,1.1-1.2c0,0,0,0,0.1,0c0.6,0,1.2,0.5,1.2,1.1c0,0,0,0.1,0,0.1L480.3,188.2z
		 M478.3,187.9h1.7c-0.1-0.5-0.5-0.8-1-0.8C478.6,187.2,478.3,187.5,478.3,187.9L478.3,187.9z"
          />
          <path
            d="M480.8,188.1c0-0.7,0.5-1.2,1.2-1.2c0,0,0.1,0,0.1,0c0.4,0,0.8,0.2,1,0.5l-0.2,0.2c-0.2-0.2-0.4-0.4-0.7-0.4
		c-0.5,0.2-0.8,0.7-0.6,1.3c0.1,0.3,0.3,0.5,0.6,0.6c0.3,0,0.5-0.1,0.7-0.4l0.2,0.2c-0.2,0.3-0.6,0.5-1,0.5
		C481.4,189.4,480.8,188.8,480.8,188.1C480.8,188.1,480.8,188.1,480.8,188.1z"
          />
          <path
            d="M484.9,189.1c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.7-0.2-0.7-0.6c0,0,0-0.1,0-0.1v-1.5h-0.4v-0.3h0.4v-0.5h0.3v0.5h0.7v0.3
		H484v1.5c0,0.2,0.1,0.4,0.3,0.4c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4-0.1L484.9,189.1z"
          />
          <path
            d="M487.6,188.2h-2c0,0.5,0.5,0.9,1,0.9c0,0,0,0,0,0c0.3,0,0.6-0.1,0.8-0.3l0.2,0.2c-0.2,0.3-0.6,0.4-0.9,0.4
		c-0.7,0-1.2-0.5-1.3-1.1c0,0,0-0.1,0-0.1c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2C487.7,188.1,487.6,188.1,487.6,188.2z
		 M485.6,187.9h1.7c-0.1-0.5-0.5-0.8-1-0.8C485.9,187.2,485.6,187.5,485.6,187.9z"
          />
          <path
            d="M489.5,189.1c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.7-0.2-0.7-0.6c0,0,0-0.1,0-0.1v-1.5h-0.4v-0.3h0.4v-0.5h0.3v0.5h0.7v0.3
		h-0.7v1.5c0,0.2,0.1,0.4,0.3,0.4c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4-0.1L489.5,189.1z"
          />
          <path
            d="M492.3,186.9v2.4H492v-0.4c-0.2,0.3-0.5,0.5-0.9,0.5c-0.6,0-1-0.4-1-1c0,0,0,0,0-0.1v-1.4h0.3v1.4c0,0.5,0.3,0.8,0.7,0.8
		c0.4,0,0.8-0.3,0.8-0.7c0,0,0-0.1,0-0.1v-1.3H492.3z"
          />
          <path
            d="M495.4,188.2h-2c0,0.5,0.4,0.9,0.9,0.9c0,0,0,0,0.1,0c0.3,0,0.6-0.1,0.7-0.3l0.2,0.2c-0.5,0.5-1.3,0.5-1.8,0
		c-0.2-0.2-0.4-0.6-0.4-0.9c0-0.6,0.5-1.2,1.1-1.2c0,0,0.1,0,0.1,0c0.6,0,1.2,0.5,1.2,1.1c0,0,0,0.1,0,0.1L495.4,188.2z
		 M493.4,187.9h1.7c-0.1-0.5-0.5-0.8-1-0.8C493.7,187.2,493.4,187.5,493.4,187.9z"
          />
          <path d="M497.3,186.8v0.3h-0.1c-0.4,0-0.8,0.3-0.8,0.8c0,0,0,0.1,0,0.1v1.2H496v-2.4h0.3v0.5C496.5,187,496.9,186.8,497.3,186.8z" />
          <path
            d="M390.4,193.3v1.5h-0.3v-0.4c-0.2,0.3-0.5,0.4-0.8,0.4c-0.5,0-0.9-0.3-0.9-0.7s0.2-0.7,0.9-0.7h0.7v-0.1
		c0-0.4-0.2-0.6-0.7-0.6c-0.3,0-0.6,0.1-0.8,0.3l-0.1-0.2c0.3-0.2,0.6-0.3,1-0.3c0.5-0.1,0.9,0.2,1,0.7
		C390.4,193.2,390.4,193.3,390.4,193.3z M390,194.1v-0.4h-0.8c-0.5,0-0.6,0.2-0.6,0.4s0.2,0.5,0.6,0.5
		C389.6,194.6,389.9,194.4,390,194.1L390,194.1z"
          />
          <path
            d="M393.5,191.4v3.4h-0.3v-0.5c-0.2,0.3-0.6,0.5-1,0.5c-0.7-0.1-1.2-0.7-1.1-1.4c0.1-0.6,0.5-1.1,1.1-1.1
		c0.4,0,0.7,0.2,0.9,0.5v-1.5H393.5z M393.2,193.6c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9
		C392.8,194.6,393.2,194.2,393.2,193.6C393.2,193.7,393.2,193.7,393.2,193.6L393.2,193.6z"
          />
          <path
            d="M394.3,191.6c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0c0,0.1-0.2,0.2-0.3,0.2
		C394.4,191.8,394.4,191.7,394.3,191.6z M394.4,192.4h0.3v2.4h-0.3V192.4z"
          />
          <path
            d="M398.1,193.6c0,0.7-0.5,1.2-1.1,1.2c0,0-0.1,0-0.1,0c-0.4,0-0.7-0.2-0.9-0.5v1.4h-0.3v-3.3h0.3v0.5
		c0.2-0.3,0.6-0.5,0.9-0.5C397.6,192.4,398.1,192.9,398.1,193.6C398.1,193.6,398.1,193.6,398.1,193.6z M397.8,193.6
		c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9S397.8,194.1,397.8,193.6z"
          />
          <path
            d="M398.7,191.6c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0c0,0.1-0.1,0.2-0.2,0.2S398.7,191.8,398.7,191.6z
		 M398.8,192.4h0.3v2.4h-0.3V192.4z"
          />
          <path
            d="M399.7,194.6l0.1-0.3c0.3,0.2,0.6,0.3,0.9,0.3c0.5,0,0.6-0.2,0.6-0.4c0-0.6-1.6-0.1-1.6-1.1c0-0.4,0.3-0.7,1-0.7
		c0.3,0,0.6,0.1,0.9,0.2l-0.1,0.3c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.6,0.2-0.6,0.4c0,0.7,1.6,0.2,1.6,1.1c0,0.4-0.4,0.7-1,0.7
		C400.4,194.9,400,194.8,399.7,194.6z"
          />
          <path
            d="M402.1,193.6c0-0.7,0.5-1.2,1.2-1.2c0,0,0.1,0,0.1,0c0.4,0,0.8,0.2,1,0.5l-0.2,0.2c-0.2-0.2-0.4-0.4-0.7-0.4
		c-0.5,0.2-0.8,0.7-0.6,1.3c0.1,0.3,0.3,0.5,0.6,0.6c0.3,0,0.5-0.1,0.7-0.4l0.2,0.2c-0.2,0.3-0.6,0.5-1,0.5
		C402.7,194.9,402.1,194.4,402.1,193.6C402.1,193.7,402.1,193.7,402.1,193.6z"
          />
          <path
            d="M404.8,191.6c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0c0,0.1-0.1,0.2-0.2,0.2S404.8,191.8,404.8,191.6z
		 M404.9,192.4h0.3v2.4h-0.3V192.4z"
          />
          <path
            d="M408.4,193.4v1.4h-0.3v-1.4c0.1-0.4-0.2-0.7-0.6-0.8c-0.1,0-0.1,0-0.2,0c-0.4,0-0.8,0.3-0.9,0.7c0,0,0,0.1,0,0.1v1.3h-0.3
		v-2.4h0.3v0.4c0.2-0.3,0.6-0.5,0.9-0.5c0.5,0,1,0.4,1,0.9C408.4,193.3,408.4,193.4,408.4,193.4z"
          />
          <path
            d="M411.6,192.4v2.2c0.1,0.6-0.3,1.1-0.9,1.2c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8-0.1-1.1-0.4l0.2-0.2c0.3,0.2,0.6,0.4,1,0.3
		c0.6,0,0.9-0.3,0.9-0.9v-0.3c-0.2,0.3-0.6,0.5-1,0.5c-0.7,0.1-1.2-0.4-1.3-1.1c-0.1-0.7,0.4-1.2,1.1-1.3c0.1,0,0.1,0,0.2,0
		c0.4,0,0.8,0.2,1,0.5v-0.5L411.6,192.4z M411.3,193.6c0-0.5-0.4-0.9-0.9-1s-0.9,0.4-1,0.9s0.4,0.9,0.9,1c0,0,0,0,0,0
		C410.8,194.5,411.2,194.2,411.3,193.6C411.3,193.6,411.3,193.6,411.3,193.6L411.3,193.6z"
          />
          <path
            d="M415.8,193.8h-2c0,0.5,0.4,0.9,0.9,0.8c0,0,0,0,0.1,0c0.3,0,0.6-0.1,0.7-0.3l0.2,0.2c-0.5,0.5-1.3,0.5-1.8,0
		c-0.2-0.2-0.4-0.6-0.4-0.9c0-0.6,0.5-1.2,1.1-1.2c0,0,0.1,0,0.1,0c0.6,0,1.2,0.5,1.2,1.1c0,0,0,0.1,0,0.1L415.8,193.8z
		 M413.8,193.5h1.7c-0.1-0.5-0.5-0.8-1-0.8C414.2,192.8,413.9,193.1,413.8,193.5z"
          />
          <path d="M416.5,191.4h0.3v3.4h-0.3V191.4z" />
          <path
            d="M417.7,191.6c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0c0,0.1-0.2,0.2-0.3,0.2
		C417.8,191.8,417.7,191.7,417.7,191.6z M417.8,192.4h0.3v2.4h-0.3V192.4z"
          />
          <path
            d="M420.3,194.7c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.7-0.2-0.7-0.6c0,0,0-0.1,0-0.1v-1.5h-0.4v-0.3h0.4v-0.5h0.3v0.5h0.7v0.3
		h-0.7v1.5c0,0.2,0.1,0.4,0.3,0.4c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.4-0.1L420.3,194.7z"
          />
          <path
            d="M421.2,194.6c0,0.1,0,0.2-0.1,0.3l-0.2,0.6h-0.2l0.2-0.7c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2
		C421.1,194.3,421.2,194.4,421.2,194.6C421.2,194.6,421.2,194.6,421.2,194.6z"
          />
          <path
            d="M422.8,194.6l0.1-0.3c0.3,0.2,0.6,0.3,0.9,0.3c0.5,0,0.6-0.2,0.6-0.4c0-0.6-1.6-0.1-1.6-1.1c0-0.4,0.3-0.7,1-0.7
		c0.3,0,0.6,0.1,0.9,0.2l-0.1,0.3c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.6,0.2-0.6,0.4c0,0.7,1.6,0.2,1.6,1.1c0,0.4-0.4,0.7-1,0.7
		C423.5,194.9,423.1,194.8,422.8,194.6z"
          />
          <path
            d="M427.5,193.8h-2c0,0.5,0.5,0.9,1,0.8c0,0,0,0,0,0c0.3,0,0.6-0.1,0.8-0.3l0.2,0.2c-0.5,0.5-1.3,0.5-1.8,0
		c-0.2-0.2-0.4-0.6-0.4-0.9c0-0.6,0.5-1.2,1.1-1.2c0,0,0.1,0,0.1,0c0.6,0,1.2,0.5,1.2,1.1c0,0,0,0.1,0,0.1L427.5,193.8z
		 M425.5,193.5h1.7c-0.1-0.5-0.5-0.8-1-0.8C425.9,192.8,425.6,193.1,425.5,193.5z"
          />
          <path
            d="M430.4,191.4v3.4h-0.3v-0.5c-0.2,0.3-0.6,0.5-0.9,0.5c-0.7-0.1-1.2-0.7-1.1-1.4c0.1-0.6,0.5-1.1,1.1-1.1
		c0.4,0,0.7,0.2,0.9,0.5v-1.5H430.4z M430.1,193.6c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9
		C429.7,194.6,430.1,194.2,430.1,193.6C430.1,193.7,430.1,193.7,430.1,193.6z"
          />
          <path
            d="M434.8,191.4v3.4h-0.3v-0.5c-0.2,0.3-0.6,0.5-0.9,0.5c-0.7-0.1-1.2-0.7-1.1-1.4c0.1-0.6,0.5-1.1,1.1-1.1
		c0.4,0,0.7,0.2,0.9,0.5v-1.5H434.8z M434.4,193.6c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9
		C434,194.6,434.4,194.2,434.4,193.6C434.4,193.7,434.4,193.7,434.4,193.6z"
          />
          <path
            d="M435.6,191.6c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.2,0.2l0,0C435.7,191.9,435.6,191.8,435.6,191.6
		C435.6,191.7,435.6,191.7,435.6,191.6z M435.7,192.4h0.3v2.4h-0.3L435.7,192.4z"
          />
          <path
            d="M438.8,193.3v1.5h-0.3v-0.4c-0.2,0.3-0.5,0.4-0.8,0.4c-0.5,0-0.9-0.3-0.9-0.7s0.2-0.7,0.9-0.7h0.8v-0.1
		c0-0.3-0.2-0.6-0.5-0.7c0,0-0.1,0-0.1,0c-0.3,0-0.6,0.1-0.8,0.3l-0.1-0.2c0.3-0.2,0.6-0.3,1-0.3c0.5-0.1,0.9,0.3,1,0.7
		C438.8,193.2,438.8,193.3,438.8,193.3z M438.4,194.1v-0.4h-0.8c-0.5,0-0.6,0.2-0.6,0.4s0.2,0.5,0.6,0.5
		C438,194.7,438.3,194.4,438.4,194.1z"
          />
          <path
            d="M443.7,193.4v1.4h-0.3v-1.4c0-0.5-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.8c0,0,0,0.1,0,0.1v1.3h-0.3v-1.4
		c0-0.5-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.8c0,0,0,0.1,0,0.1v1.3h-0.3v-2.4h0.3v0.4c0.2-0.3,0.5-0.5,0.9-0.5
		c0.4,0,0.7,0.2,0.9,0.5c0.2-0.4,0.6-0.6,1-0.5c0.5,0,0.9,0.4,0.9,0.9C443.7,193.4,443.7,193.4,443.7,193.4z"
          />
          <path d="M446.5,192.6l-1.6,0.6l1.6,0.6v0.4l-2.1-0.8V193l2.1-0.8V192.6z" />
          <path d="M448.2,191h0.4l-1.5,4.4h-0.4L448.2,191z" />
          <path d="M451.7,191.6v3.2h-0.5v-1.4h-1.9v1.4h-0.5v-3.2h0.5v1.4h1.9v-1.4H451.7z" />
          <path d="M453.4,191.6v3.2H453V192h-0.7v-0.4H453.4z" />
          <path d="M456.3,193v0.4l-2.1,0.8v-0.4l1.7-0.6l-1.7-0.6v-0.4L456.3,193z" />
          <path d="M390.5,203.7l-1.6,0.6l1.6,0.6v0.4l-2.1-0.8v-0.4l2.1-0.8V203.7z" />
          <path
            d="M393.9,203.9c0,0.7-0.5,1.1-1.4,1.1h-0.8v1h-0.5v-3.2h1.3C393.4,202.7,393.9,203.2,393.9,203.9z M393.4,203.9
		c0-0.5-0.3-0.7-0.9-0.7h-0.8v1.4h0.8C393.1,204.6,393.4,204.3,393.4,203.9z"
          />
          <path d="M396.5,204.2v0.4l-2.1,0.8V205l1.6-0.6l-1.6-0.6v-0.4L396.5,204.2z" />
          <path d="M400.4,203.7l-1.6,0.6l1.6,0.6v0.4l-2.1-0.8v-0.4l2.1-0.8V203.7z" />
          <path d="M401.2,202.7h0.5v3.2h-0.5V202.7z" />
          <path d="M405.7,206v-2.4l-1.2,2h-0.2l-1.2-2v2.4h-0.4v-3.2h0.4l1.4,2.3l1.3-2.3h0.4v3.2L405.7,206z" />
          <path
            d="M409.3,204.3h0.5v1.2c-0.4,0.3-0.8,0.4-1.2,0.4c-0.9,0-1.6-0.8-1.6-1.7s0.8-1.6,1.7-1.6c0.4,0,0.8,0.2,1.1,0.5l-0.3,0.3
		c-0.2-0.3-0.6-0.4-0.9-0.4c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2c0.3,0,0.5-0.1,0.8-0.2L409.3,204.3z"
          />
          <path
            d="M411.6,205.6l0.2-0.4c0.3,0.2,0.7,0.4,1.1,0.4c0.6,0,0.8-0.2,0.8-0.5c0-0.8-2-0.3-2-1.5c0-0.5,0.4-0.9,1.2-0.9
		c0.4,0,0.7,0.1,1,0.3l-0.2,0.4c-0.3-0.2-0.6-0.3-0.9-0.3c-0.5,0-0.8,0.2-0.8,0.5c0,0.8,2,0.3,2,1.5c0,0.5-0.4,0.9-1.3,0.9
		C412.4,206,412,205.9,411.6,205.6z"
          />
          <path
            d="M417,206l-0.7-1h-1v1h-0.5v-3.2h1.3c0.9,0,1.4,0.4,1.4,1.1c0,0.5-0.3,0.9-0.7,1l0.8,1.1L417,206z M417,203.9
		c0-0.5-0.3-0.7-0.9-0.7h-0.8v1.4h0.8C416.6,204.6,417,204.3,417,203.9z"
          />
          <path
            d="M417.9,204.4c0-0.9,0.7-1.6,1.6-1.7c0,0,0.1,0,0.1,0c0.5,0,0.9,0.2,1.2,0.5l-0.3,0.3c-0.2-0.3-0.6-0.4-0.9-0.4
		c-0.7,0-1.2,0.6-1.2,1.2s0.6,1.2,1.2,1.2c0.3,0,0.7-0.1,0.9-0.4l0.3,0.3c-0.3,0.3-0.8,0.5-1.2,0.5c-0.9,0-1.7-0.7-1.7-1.6
		C417.9,204.4,417.9,204.4,417.9,204.4z"
          />
          <path d="M421.3,203.6h2.1v0.4h-2.1V203.6z M421.3,204.7h2.1v0.4h-2.1V204.7z" />
          <path d="M425.3,202.7h0.4v1.2h-0.3L425.3,202.7z M426.1,202.7h0.4v1.2h-0.3L426.1,202.7z" />
          <path d="M427.3,202.7h0.5v2.9h1.8v0.4h-2.2V202.7z" />
          <path
            d="M429.7,204.8c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3c0,0,0,0,0,0c-0.7,0-1.2-0.5-1.3-1.2
		C429.7,204.8,429.7,204.8,429.7,204.8z M431.8,204.8c0.1-0.5-0.3-0.9-0.7-0.9c-0.5-0.1-0.9,0.3-0.9,0.7c0,0.1,0,0.1,0,0.2
		c-0.1,0.5,0.3,0.9,0.7,0.9c0.5,0.1,0.9-0.3,0.9-0.7C431.8,204.9,431.8,204.8,431.8,204.8z"
          />
          <path
            d="M434.2,203.5v0.4h-0.1c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0.1,0,0.1v1.2h-0.4v-2.4h0.4v0.4C433.5,203.6,433.8,203.5,434.2,203.5
		z"
          />
          <path
            d="M436.9,204.9h-2c0.1,0.4,0.4,0.8,0.9,0.7c0.3,0,0.5-0.1,0.7-0.3l0.2,0.3c-0.5,0.5-1.4,0.5-1.9,0c-0.2-0.2-0.4-0.5-0.4-0.9
		c0-0.7,0.5-1.2,1.2-1.2c0,0,0,0,0.1,0c0.7,0,1.2,0.5,1.2,1.1c0,0,0,0.1,0,0.1V204.9z M434.9,204.6h1.6c-0.1-0.4-0.5-0.7-0.9-0.7
		C435.3,204,435,204.2,434.9,204.6z"
          />
          <path
            d="M441.6,204.6v1.4h-0.4v-1.4c0-0.5-0.2-0.7-0.6-0.7s-0.7,0.3-0.7,0.8v1.3h-0.4v-1.4c0-0.5-0.2-0.7-0.6-0.7
		c-0.4,0-0.7,0.3-0.7,0.7c0,0,0,0.1,0,0.1v1.3h-0.4v-2.4h0.5v0.4c0.2-0.3,0.5-0.4,0.8-0.4c0.4,0,0.7,0.2,0.9,0.5
		c0.2-0.3,0.6-0.5,0.9-0.5c0.6,0,1,0.5,1,1C441.6,204.5,441.6,204.6,441.6,204.6z"
          />
          <path
            d="M443.6,202.8c0-0.2,0.1-0.3,0.3-0.3c0,0,0,0,0,0c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3
		C443.8,203.1,443.6,202.9,443.6,202.8C443.6,202.8,443.6,202.8,443.6,202.8z M443.7,203.5h0.5v2.4h-0.5V203.5z"
          />
          <path
            d="M447.5,204.8c0,0.7-0.5,1.2-1.1,1.3c0,0-0.1,0-0.1,0c-0.3,0-0.7-0.1-0.9-0.4v1.3H445v-3.4h0.4v0.4c0.2-0.3,0.5-0.4,0.9-0.4
		c0.7,0,1.2,0.5,1.2,1.1C447.5,204.7,447.5,204.7,447.5,204.8z M447.1,204.8c0-0.5-0.4-0.8-0.9-0.8c-0.5,0-0.8,0.4-0.8,0.9
		c0,0.4,0.4,0.8,0.8,0.8C446.7,205.6,447.1,205.3,447.1,204.8C447.1,204.8,447.1,204.8,447.1,204.8z"
          />
          <path
            d="M447.8,205.7l0.2-0.4c0.3,0.2,0.6,0.3,0.9,0.3c0.4,0,0.6-0.1,0.6-0.3c0-0.6-1.6-0.1-1.6-1c0-0.4,0.4-0.7,1-0.7
		c0.3,0,0.6,0.1,0.9,0.2l-0.2,0.4c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.6,0.1-0.6,0.3c0,0.6,1.5,0.1,1.5,1.1c0,0.4-0.4,0.7-1.1,0.7
		C448.5,206.1,448.1,205.9,447.8,205.7z"
          />
          <path
            d="M452.8,203.5v2.4h-0.4v-0.4c-0.2,0.3-0.5,0.4-0.8,0.4c-0.6,0-1-0.4-1.1-0.9c0,0,0-0.1,0-0.1v-1.4h0.5v1.4
		c0,0.5,0.2,0.7,0.7,0.7c0.4,0,0.7-0.3,0.8-0.7c0-0.1,0-0.1,0-0.2v-1.3L452.8,203.5z"
          />
          <path
            d="M457.7,204.6v1.4h-0.5v-1.4c0-0.5-0.2-0.7-0.6-0.7s-0.7,0.3-0.7,0.8v1.3h-0.5v-1.4c0-0.5-0.2-0.7-0.6-0.7s-0.7,0.3-0.7,0.8
		v1.3h-0.4v-2.4h0.4v0.4c0.2-0.3,0.5-0.4,0.9-0.4c0.3,0,0.7,0.2,0.9,0.5c0.2-0.3,0.6-0.5,1-0.5c0.6,0,1,0.4,1,1
		C457.7,204.5,457.7,204.5,457.7,204.6z"
          />
          <path d="M458.4,202.7h0.4v1.2h-0.3L458.4,202.7z M459.2,202.7h0.4v1.2h-0.3L459.2,202.7z" />
          <path d="M462.3,204.2v0.4l-2.1,0.8V205l1.6-0.6l-1.6-0.6v-0.4L462.3,204.2z" />
          <path d="M465,203.7l-1.6,0.6l1.6,0.6v0.4l-2.1-0.8v-0.4l2.1-0.8L465,203.7z" />
          <path d="M466.7,202.1h0.4l-1.5,4.4h-0.4L466.7,202.1z" />
          <path
            d="M470,203.9c0,0.7-0.5,1.1-1.4,1.1h-0.8v1h-0.5v-3.2h1.3C469.5,202.7,470,203.2,470,203.9z M469.5,203.9
		c0-0.5-0.3-0.7-0.9-0.7h-0.8v1.4h0.8C469.3,204.6,469.6,204.3,469.5,203.9L469.5,203.9z"
          />
          <path d="M472.7,204.2v0.4l-2.1,0.8V205l1.7-0.6l-1.7-0.6v-0.4L472.7,204.2z" />
          <path d="M390.5,214.8l-1.6,0.6l1.6,0.6v0.4l-2.1-0.8v-0.4l2.1-0.8V214.8z" />
          <path d="M392.2,213.2h0.4l-1.6,4.4h-0.4L392.2,213.2z" />
          <path
            d="M395.7,216.2c0,0.6-0.4,0.9-1.2,0.9h-1.5v-3.2h1.5c0.8,0,1.2,0.3,1.2,0.8c0,0.3-0.2,0.6-0.4,0.7
		C395.4,215.5,395.7,215.8,395.7,216.2z M393.3,214.2v1h1c0.5,0,0.8-0.2,0.8-0.5s-0.3-0.5-0.8-0.5L393.3,214.2z M395.2,216.2
		c0-0.4-0.3-0.5-0.8-0.5h-1.1v1.1h1.1C394.9,216.7,395.2,216.6,395.2,216.2L395.2,216.2z"
          />
          <path
            d="M396.1,215.5c0-1,0.7-1.8,1.7-1.8c1,0,1.8,0.7,1.8,1.7c0,1-0.7,1.8-1.7,1.8c0,0,0,0-0.1,0
		C396.9,217.2,396.2,216.5,396.1,215.5C396.1,215.5,396.1,215.5,396.1,215.5z M399.1,215.5c0-0.7-0.6-1.3-1.2-1.3s-1.3,0.6-1.3,1.2
		c0,0.7,0.6,1.3,1.2,1.3c0,0,0,0,0,0C398.5,216.7,399.1,216.2,399.1,215.5C399.1,215.5,399.1,215.5,399.1,215.5L399.1,215.5z"
          />
          <path
            d="M400.3,213.9h1.4c0.9-0.1,1.7,0.6,1.8,1.5c0.1,0.9-0.6,1.7-1.5,1.8c-0.1,0-0.2,0-0.3,0h-1.4V213.9z M401.6,216.7
		c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2h-0.9v2.4H401.6z"
          />
          <path d="M405.2,216v1.1h-0.5V216l-1.3-2.1h0.5l1,1.7l1-1.7h0.5L405.2,216z" />
          <path d="M408.9,215.3v0.4l-2.1,0.8v-0.4l1.6-0.6l-1.6-0.6v-0.4L408.9,215.3z" />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M515.2,127.9c0,0.1-32.1,0.3-71.7,0.3s-71.7-0.1-71.7-0.3s32.1-0.3,71.7-0.3S515.2,127.8,515.2,127.9z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M376.2,122.8c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9
		C375.7,121.9,376.2,122.3,376.2,122.8z"
          />
          <circle className="st7" fill={theme.imageClothes} cx="378.8" cy="122.8" r="0.9" />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M383.2,122.8c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9c0,0,0,0,0,0
		C382.8,121.9,383.2,122.3,383.2,122.8z"
          />
          <path
            className="st4"
            d="M381,236.4c-0.1,0-0.3-24.3-0.3-54.3s0.1-54.3,0.3-54.3s0.3,24.3,0.3,54.3S381.1,236.4,381,236.4z"
          />
        </g>

        <g id="Character">
          <path
            className="st9"
            d="M247.9,239.6l26.1,88.1c1.2,3.9,4.8,6.6,8.8,6.6l106,0.3c5.4,0,9.8-4.4,9.8-9.8c0-0.2,0-0.4,0-0.5l0,0
		c-0.3-5.2-4.6-9.3-9.8-9.3h-40.5l-32.5-90.4h-56.8c-6.4,0-11.7,5.2-11.7,11.7C247.4,237.4,247.6,238.5,247.9,239.6z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M337.6,322.3c0,0.2-10.8,0.4-24.1,0.4c-13.3,0-24.1-0.2-24.1-0.4s10.8-0.4,24.1-0.4
		C326.8,321.9,337.6,322,337.6,322.3z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M255.7,227.4c0.2-0.1,7.4,21,16.1,47.2s15.6,47.3,15.4,47.4s-7.4-21-16.1-47.2S255.5,227.4,255.7,227.4z"
          />
          <polygon className="st9" points="333.2,412.7 326.7,412.5 326.7,334.3 333.2,334.3 	" />
          <polygon className="st9" points="299.9,412.3 360,412.3 332.8,402.9 326.3,402.9 	" />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M284.7,204.3l10,49.7l-1.8,37.2l66.9-11.1l-2.6-32.6l-0.1-27l16.4,31.8l12.8-24.7l-23.4-42.4l0,0
		c-4.3-4.4-9.5-7.8-15.3-9.9c-3.1-1.1-6.3-1.7-9.6-1.8l0,0c-7.5,2.4-15.6,2.4-23.1,0c-0.9,0.1-2.2,0.2-3.9,0.4h-0.3
		c-14.2,1.8-25.1,13.5-25.8,27.8L284.7,204.3z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M310.9,174.1c0,0-27.5,0.2-30.9,29.2l-0.5,21.3l23.7-0.2L310.9,174.1z"
          />
          <path
            className="st10"
            d="M376.5,211.4c0,0.2-21.6,0.4-48.3,0.4s-48.2-0.2-48.2-0.4s21.6-0.4,48.3-0.4C355,211,376.5,211.2,376.5,211.4
		z"
          />
          <path
            className="st10"
            d="M376.5,216c0,0.2-21.6,0.4-48.3,0.4S280,216.2,280,216s21.6-0.4,48.3-0.4C354.9,215.6,376.5,215.8,376.5,216z
		"
          />
          <path
            className="st10"
            d="M375,207.6c0,0.2-21.3,0.4-47.5,0.4s-47.5-0.2-47.5-0.4s21.3-0.4,47.5-0.4S375,207.4,375,207.6z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M356.7,252.4c-0.2,0-0.1-11.8,0.2-26.3s0.8-26.3,1-26.3s0.1,11.8-0.2,26.3S356.9,252.4,356.7,252.4z"
          />
          <path
            className="st11"
            d="M347.3,233.3c0,0,13,0.9,15.3,4.4s5.9,13.2,4.6,13.3c-0.8,0-1.7-0.2-2.3-0.7l-3.6-6.3c0,0,0.6,6.1-1.6,6.2
		s-12.7,2.2-12.7,2.2L347.3,233.3z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M279.6,218.9l0,33.5c0.4,7,6.4,12.4,13.4,12c0.7,0,1.4-0.1,2-0.3l52.4-10.8l-0.1-21.5l-45.2,8.7l-0.6-22.8
		L279.6,218.9z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M309.5,261.5c0.2-0.1,0.5-0.1,0.7-0.2l2-0.5l7.7-1.6l27.3-5.6l-0.3,0.3c0-6.7,0-14.2,0-22.1l0.4,0.4l-9.2,1.8
		l-36,6.9l-0.4,0.1v-0.3c0.3-10,0.6-18.3,0.8-24.2c0.1-2.9,0.2-5.1,0.3-6.8c0-0.7,0.1-1.3,0.1-1.8c0-0.2,0-0.4,0.1-0.6
		c0,0.2,0,0.4,0,0.6c0,0.5,0,1,0,1.8c0,1.6-0.1,3.9-0.1,6.8c-0.1,5.9-0.3,14.2-0.6,24.2l-0.4-0.3l36-7l9.2-1.8l0.4-0.1v0.5
		c0,7.9,0,15.3,0,22.1v0.3l-0.3,0l-27.4,5.3l-7.7,1.5l-2.1,0.4C310,261.5,309.7,261.5,309.5,261.5z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M339.5,174.1c0,0,0.1,0.2,0.2,0.5c0.2,0.5,0.3,1,0.4,1.5c0.4,1.9,0.3,3.8-0.2,5.6c-0.8,2.7-2.4,5.1-4.5,7
		c-2.6,2.3-6,3.6-9.5,3.6c-3.5,0.1-6.9-1.3-9.4-3.8c-2-2.1-3.2-4.7-3.5-7.6c-0.2-1.9,0-3.8,0.7-5.6c0.2-0.5,0.4-0.9,0.7-1.4
		c0.2-0.3,0.3-0.4,0.3-0.4s-0.3,0.7-0.7,1.9c-0.5,1.8-0.7,3.6-0.4,5.4c0.4,2.7,1.6,5.2,3.5,7.2c2.4,2.3,5.6,3.6,8.9,3.6
		c3.3,0,6.6-1.2,9.1-3.4c2.1-1.8,3.7-4.1,4.5-6.7c0.5-1.8,0.7-3.6,0.5-5.4C339.7,174.8,339.4,174.1,339.5,174.1z"
          />
          <path
            className="st10"
            d="M342.1,255.1c-0.1-1.1-0.1-2.2,0-3.3c0.1-2,0.2-4.8,0.2-7.9c0-3.1,0-5.9-0.1-8c-0.1-1.1-0.1-2.2,0-3.3
		c0.3,1.1,0.5,2.2,0.5,3.3c0.2,2,0.3,4.9,0.3,8s-0.2,5.9-0.4,8C342.5,253,342.4,254.1,342.1,255.1z"
          />
          <path
            className="st10"
            d="M339.3,255.7c-0.1-1.1-0.2-2.2-0.1-3.3c0-2.3,0.1-5,0.1-7.9v-7.9c-0.1-1.1,0-2.2,0.1-3.3
		c0.3,1.1,0.4,2.2,0.4,3.3c0.1,2,0.2,4.8,0.2,7.9c0,3.1-0.1,5.9-0.3,7.9C339.8,253.5,339.6,254.6,339.3,255.7z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M391.8,388.8l9.9,27.3l14.1,19.3c1,1.3,0.6,3.2-0.7,4.2c0,0-0.1,0.1-0.1,0.1l0,0c-0.8,0.5-1.8,0.6-2.7,0.2
		c-5.7-2.4-26.5-11.1-27.1-13.1c-0.7-2.4-14.1-31.7-14.1-31.7L391.8,388.8z"
          />
          <g className="st12">
            <path
              className="st6"
              d="M415,439.7L384.5,425l0.5,1.1c0.4,1,1.1,1.8,2,2.3c2.5,1.4,9.5,4.9,25.2,11.5
			C413.1,440.3,414.1,440.2,415,439.7L415,439.7z"
            />
          </g>
          <g className="st12">
            <path
              className="st6"
              d="M386.6,414.1c0.9,0.2,1.4,1.1,1.3,2c-0.2,0.9-1.1,1.5-2,1.3c-0.9-0.2-1.5-1.2-1.4-2.1
			c0.3-0.9,1.3-1.4,2.2-1.1"
            />
          </g>
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M404.2,430.3c0.3-1.1,0.9-2.1,1.6-3c1.3-1.4,2.9-1.6,2.9-1.8s-0.4-0.1-1.1,0c-1.8,0.5-3.1,1.9-3.4,3.7
		C404,429.9,404.1,430.3,404.2,430.3z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M407.5,433.2c0.2,0.1,0.7-1.1,1.9-2.1c0.8-0.5,1.6-1,2.5-1.4c0-0.2-1.5-0.2-2.9,0.9S407.4,433.1,407.5,433.2z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M398.8,427c0.2,0.1,1-1.8,2.8-3.4s3.7-2.3,3.6-2.5s-2.2,0.2-4.1,2S398.6,427,398.8,427z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M395.1,419c0.1,0.1,1.4-1.1,3.3-1.9s3.6-1,3.6-1.1s-1.8-0.3-3.9,0.6S395,418.9,395.1,419z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M392,411.1c0.1,0.1,1.3-1.4,3.4-2.1s3.9-0.3,3.9-0.5s-0.4-0.3-1.2-0.4c-2-0.3-4.1,0.4-5.5,1.9
		C392.1,410.6,391.9,411,392,411.1z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M394.7,407.5c-0.1-0.4-0.2-0.7-0.4-1c-0.5-0.9-1.1-1.7-1.9-2.4c-0.5-0.5-1.2-0.9-1.9-1c-0.5,0-1,0.3-1.2,0.7
		c-0.2,0.4-0.2,0.9,0,1.4c0.8,1.9,2.9,2.8,4.9,2.3c1.9-0.5,3.3-2.1,3.5-4.1c0.1-0.5-0.1-1-0.4-1.3c-0.4-0.3-0.9-0.4-1.4-0.1
		c-0.6,0.4-1.1,1-1.4,1.6c-0.5,0.9-0.8,1.8-1,2.8c-0.1,0.4-0.1,0.7,0,1.1c0.3-1.3,0.8-2.5,1.5-3.7c0.3-0.6,0.7-1,1.3-1.4
		c0.2-0.1,0.5-0.1,0.8,0.1c0.2,0.3,0.3,0.6,0.2,0.9c-0.3,1.7-1.5,3.1-3.1,3.5c-1.7,0.4-3.4-0.4-4.1-1.9c-0.2-0.3-0.2-0.7-0.1-1
		c0.1-0.3,0.4-0.4,0.6-0.4c0.6,0.1,1.2,0.4,1.6,0.8C393.3,405.3,394.1,406.4,394.7,407.5z"
          />
          <path
            className="st8"
            fill={theme.accentColor[0]}
            d="M433.6,381.7l-0.9,22.2c0,0,22.2,8.3,22.5,12.4l-43-0.1l-0.1-34.6L433.6,381.7z"
          />
          <g className="st12">
            <path
              className="st6"
              d="M419.5,402c-0.9,0.3-1.4,1.1-1.2,2c0.2,0.9,1.1,1.4,2,1.2c0.9-0.3,1.5-1.2,1.3-2.1c-0.3-0.9-1.3-1.3-2.2-1"
            />
          </g>
          <g className="st12">
            <path className="st6" d="M412.2,416.2v-3.5l41.4,1.4c0,0,1.9,0.8,1.7,2.2L412.2,416.2z" />
          </g>
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M433.5,403.6c0,0.2-1,0.3-2.1,1s-1.6,1.6-1.8,1.5s0.1-1.3,1.4-2.1S433.5,403.5,433.5,403.6z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M438,405.5c0,0.2-0.9,0.6-1.6,1.5s-0.9,1.8-1.1,1.8s-0.3-1.2,0.6-2.3S438,405.3,438,405.5z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M440.5,410.9c-0.2,0-0.5-1,0.1-2.1s1.5-1.6,1.6-1.4s-0.5,0.8-1,1.7S440.8,410.9,440.5,410.9z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M433.1,398.6c-0.1,0.2-1-0.1-2.2,0s-2.1,0.5-2.2,0.3s0.8-0.9,2.2-1S433.2,398.4,433.1,398.6z"
          />
          <g className="st13">
            <polygon points="433.5,386.1 433.3,390 412.2,389.8 412.2,386.2 		" />
          </g>
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M433.2,394.1c-0.7,0.2-1.5,0.2-2.2,0c-0.8-0.1-1.5-0.4-2.2-0.7c-0.4-0.2-0.8-0.4-1.2-0.7
		c-0.2-0.1-0.5-0.3-0.6-0.5c-0.3-0.3-0.3-0.8-0.1-1.1c0.2-0.3,0.6-0.5,0.9-0.5c0.3,0,0.5,0,0.8,0.1c0.5,0.1,0.9,0.3,1.3,0.5
		c0.7,0.3,1.4,0.8,2,1.3c1,0.9,1.3,1.7,1.3,1.8s-0.6-0.6-1.6-1.4c-0.6-0.4-1.2-0.8-1.9-1.1c-0.4-0.2-0.8-0.3-1.2-0.4
		c-0.5-0.1-0.9-0.1-1,0.1s0,0.1,0,0.2c0.1,0.1,0.3,0.3,0.5,0.4c0.4,0.2,0.7,0.5,1.1,0.6c0.7,0.3,1.4,0.6,2.1,0.8
		C431.8,393.7,432.5,393.9,433.2,394.1z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M432.9,394.4c-0.4-0.6-0.6-1.4-0.6-2.1c0-0.8,0.1-1.6,0.3-2.4c0.1-0.4,0.3-0.9,0.5-1.3c0.2-0.6,0.8-1,1.4-1.1
		c0.4,0,0.7,0.2,0.9,0.6c0.1,0.3,0.2,0.5,0.2,0.8c0.1,0.5,0.1,1,0,1.5c-0.1,0.8-0.4,1.6-0.9,2.2c-0.8,1.1-1.7,1.4-1.7,1.3
		s0.7-0.5,1.3-1.6c0.4-0.6,0.6-1.3,0.7-2c0.1-0.4,0.1-0.8,0-1.2c-0.1-0.5-0.2-0.8-0.4-0.8s-0.6,0.3-0.8,0.7
		c-0.2,0.4-0.4,0.8-0.5,1.2c-0.2,0.7-0.4,1.4-0.4,2.1C432.8,393.6,433.1,394.4,432.9,394.4z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M412.2,275.4c-25.4,2.6-59.1,6.1-59.1,6.1l4.6,41.4c0,0,49.5-13.1,49.2-12s2.3,88.1,2.3,88.1h29.8l0.6-98.5
		c0.2-13.7-10.7-24.9-24.4-25.1C414.1,275.3,413.2,275.3,412.2,275.4z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M292.2,292.1V305c0,8.7,9.9,18,18.7,18h6.8c5.3,0,13.7-3.9,18-7l2.6-1.9l31.1,96.2c0,0,35.5-6.4,35.5-7.5
		s-24.1-78.8-35.2-114.9c-4.5-14.7-20.3-23.3-34.9-18.3c-0.5,0.2-1,0.4-1.5,0.6C317.3,276.6,292.2,292.1,292.2,292.1z"
          />
          <path
            className="st9"
            d="M404.8,402.8c-0.1-0.1-0.1-0.2-0.1-0.3c-0.1-0.3-0.2-0.6-0.4-1c-0.3-0.9-0.8-2.2-1.4-4
		c-1.2-3.5-2.8-8.5-4.8-14.8c-4-12.5-9.3-29.9-15.1-49.1c-2.9-9.6-5.6-18.8-8.1-27.1c-1.2-4.2-2.4-8.1-3.5-11.8
		c-0.6-1.9-1.1-3.6-1.6-5.4c-0.5-1.6-1-3.3-1.6-4.9c-1.1-2.7-2.8-5.1-5-7.1c-1.6-1.5-3.4-2.9-5.3-4.1c-1.5-1-2.7-1.8-3.6-2.3
		l-0.9-0.6c-0.1-0.1-0.2-0.1-0.3-0.2c0.1,0,0.2,0.1,0.3,0.2l1,0.5c0.9,0.5,2.1,1.2,3.6,2.2c1.9,1.2,3.7,2.5,5.4,4
		c2.3,2,4,4.4,5.2,7.2c0.6,1.6,1.2,3.2,1.7,4.9c0.5,1.7,1.1,3.5,1.6,5.4l3.6,11.8c2.5,8.3,5.3,17.5,8.2,27.1
		c5.8,19.2,11,36.5,14.8,49.2l4.6,14.9l1.3,4c0.1,0.4,0.2,0.8,0.3,1S404.8,402.8,404.8,402.8z"
          />
          <path
            className="st9"
            d="M412.3,298.5c0.2,0.1-1.5,2.7-2.9,6.1s-2,6.4-2.3,6.4s0.1-3.1,1.6-6.7S412.1,298.4,412.3,298.5z"
          />
          <path
            className="st9"
            d="M418,302.5c0.1,0.2-2.5,1.3-5.1,3.4s-4.4,4.3-4.6,4.2s1.3-2.6,4.1-4.8S417.9,302.3,418,302.5z"
          />
          <path
            className="st9"
            d="M369.6,410.3c-0.2,0.1-8.6-25.7-18.7-57.5c-10.2-31.8-18.2-57.7-18-57.7s8.6,25.7,18.7,57.5
		S369.8,410.2,369.6,410.3z"
          />
          <polygon
            className="st9"
            points="331.5,260.2 433.1,261.2 452.1,207.6 378.1,208.1 361,256.3 331.5,256.7 	"
          />
          <path
            className="st6"
            d="M408.5,239c-2.3-0.3-3.8-2.4-3.5-4.7c0.3-2.3,2.4-3.8,4.7-3.5c2.3,0.3,3.8,2.4,3.5,4.7c0,0,0,0,0,0
		C412.9,237.7,410.8,239.3,408.5,239z"
          />
          <path
            className="st7"
            fill={theme.dark}
            d="M323.2,115.2c1-3.6,3.6-5.3,7.1-6.5c3.6-1.2,7.5-0.6,10.5,1.7c2,1.5,3.5,3.7,5.8,4.5c3.8,1.3,8.3-1.5,12,0.2
		c2.6,1.2,3.8,4.3,2.6,6.9c-0.9,2-2.9,3.2-5.1,3.1c2.5,0.9,3.3,4.5,1.8,6.7s-4.5,3.1-7.1,2.6c-2.6-0.6-5-2-6.9-3.9
		c-2-1.8-3.8-3.8-5.9-5.4c-2.1-1.7-4.7-2.7-7.4-2.7c-3.6,0.2-6.7,2.9-8.3,6.1c-1.6,3.2-2,6.9-2.2,10.5s-0.3,7.3-1.3,10.7
		c-0.1,0.4-0.3,0.9-0.7,1c-0.6,0.2-1.1-0.4-1.4-1c-3.3-6.1-5.3-12.8-6.1-19.7c-0.4-4-0.3-7.8,1.9-11.1
		C314.9,115.5,320.4,113,323.2,115.2"
          />
          <path
            className="st11"
            d="M316.2,131.9l-1.9,40.5c-0.3,6.9,0.6,17.1,11.5,17.1l0,0c9.5-0.7,12.2-9.6,12.5-16c0.1-3,0.2-5.6,0.3-5.9
		c0,0,10.3-0.5,11.6-10.7c0.6-4.9,1-15.1,1.2-24.4c0.2-9.9-7.1-18.4-17-19.4l-1-0.1C322.8,112.5,316.4,121.2,316.2,131.9z"
          />
          <path
            className="st14"
            d="M338.8,167.4c-4.7-0.4-9.2-2.2-12.9-5.2c0,0,2.4,7.6,12.6,7.8L338.8,167.4z"
          />
          <path
            className="st7"
            fill={theme.dark}
            d="M347.8,139c-0.1,0.8-0.8,1.4-1.6,1.3c-0.8,0-1.4-0.7-1.4-1.4c0,0,0,0,0,0c0.1-0.8,0.8-1.4,1.6-1.3
		C347.2,137.6,347.8,138.2,347.8,139C347.8,139,347.8,139,347.8,139z"
          />
          <path
            className="st7"
            fill={theme.dark}
            d="M348.8,137.3c-0.2,0.2-1.2-0.8-2.8-0.9c-1.6-0.2-2.8,0.5-2.9,0.3c-0.1-0.2,0.1-0.4,0.7-0.7
		c0.7-0.4,1.6-0.6,2.4-0.5c0.8,0.1,1.6,0.4,2.2,1C348.7,136.8,348.9,137.2,348.8,137.3z"
          />
          <path
            className="st7"
            fill={theme.dark}
            d="M332.4,137.9c-0.1,0.8-0.8,1.4-1.6,1.3c-0.8,0-1.4-0.7-1.4-1.5c0,0,0,0,0,0c0.1-0.8,0.8-1.4,1.6-1.3
		C331.8,136.5,332.4,137.1,332.4,137.9C332.4,137.9,332.4,137.9,332.4,137.9z"
          />
          <path
            className="st7"
            fill={theme.dark}
            d="M333.4,135.9c-0.2,0.2-1.2-0.8-2.8-0.9c-1.6-0.2-2.8,0.5-2.9,0.3c-0.1-0.2,0.1-0.4,0.7-0.7
		c0.7-0.4,1.6-0.6,2.4-0.5c0.8,0.1,1.6,0.4,2.2,1C333.3,135.5,333.5,135.8,333.4,135.9z"
          />
          <path
            className="st7"
            fill={theme.dark}
            d="M337.8,148.1c0.9-0.2,1.7-0.2,2.6-0.2c0.4,0,0.8,0,0.9-0.3c0.1-0.4,0-0.8-0.1-1.2c-0.3-1-0.6-2.1-0.9-3.2
		c-1.2-4.5-2-8.2-1.8-8.2s1.3,3.6,2.5,8.1c0.3,1.1,0.6,2.2,0.8,3.2c0.2,0.5,0.2,1.1,0,1.6c-0.1,0.3-0.4,0.5-0.7,0.5
		c-0.2,0-0.5,0-0.7,0C339.5,148.4,338.6,148.3,337.8,148.1z"
          />
          <path
            className="st7"
            fill={theme.dark}
            d="M333.1,148.7c0.2,0,0.1,1.7,1.4,3.1c1.3,1.4,3.1,1.4,3.1,1.6c0,0.2-0.4,0.3-1.2,0.2c-1-0.1-1.9-0.5-2.6-1.2
		c-0.7-0.7-1.1-1.6-1.1-2.6C332.7,149.1,333,148.7,333.1,148.7z"
          />
          <path
            className="st7"
            fill={theme.dark}
            d="M334.4,129.8c-0.2,0.4-1.7,0-3.6,0.1c-1.9,0.1-3.4,0.4-3.6,0c-0.1-0.2,0.2-0.6,0.9-0.9c1.7-0.9,3.8-0.9,5.5,0
		C334.2,129.3,334.5,129.6,334.4,129.8z"
          />
          <path
            className="st7"
            fill={theme.dark}
            d="M348.7,132.7c-0.3,0.3-1.4-0.2-2.6-0.3c-1.3-0.2-2.4,0-2.6-0.4c-0.1-0.2,0.1-0.5,0.6-0.8
		c0.7-0.3,1.5-0.5,2.2-0.4c0.7,0.1,1.4,0.4,2,0.9C348.7,132.1,348.8,132.5,348.7,132.7z"
          />
          <path
            className="st11"
            d="M316.2,139.5c-0.2-0.1-6.8-2.8-7.3,4.2s6.6,6.1,6.6,5.9S316.2,139.5,316.2,139.5z"
          />
          <path
            className="st14"
            d="M313.6,146.7c0,0-0.1,0.1-0.3,0.2c-0.3,0.1-0.6,0.1-0.9-0.1c-0.9-0.7-1.3-1.7-1.2-2.8c0-0.6,0.2-1.2,0.5-1.7
		c0.2-0.4,0.5-0.8,1-0.9c0.3,0,0.6,0.1,0.7,0.4c0.1,0.2,0,0.3,0.1,0.4s0.2-0.1,0.1-0.4c0-0.2-0.1-0.3-0.2-0.4
		c-0.2-0.2-0.4-0.2-0.7-0.2c-0.6,0.1-1.1,0.5-1.4,1c-0.3,0.6-0.5,1.2-0.6,1.9c-0.1,1.4,0.6,2.8,1.5,3.1c0.4,0.1,0.8,0.1,1.1-0.1
		C313.6,146.9,313.7,146.8,313.6,146.7z"
          />
          <path
            className="st7"
            fill={theme.dark}
            d="M353.9,130.6c-4.7,0.7-9.4-0.9-12.7-4.3c-2.2-2.4-3.8-5.6-6.8-6.9c-2.1-0.8-4.4-0.7-6.4,0.2
		c-2,0.9-3.8,2.3-5.3,3.9c1.4,5.4-0.5,11-2.4,16.2c-0.2,0.6-0.5,1.1-1,1.5c-0.9,0.6-2.1-0.1-2.7-0.9c-0.9-1.4-1.4-3.1-1.4-4.7
		c-0.3-3.8,0.1-7.6,1.3-11.3c1.2-3.6,3.4-6.9,6.4-9.3c3.9-2.9,8.7-4.1,13.5-3.5c4.7,0.6,9.2,2.8,12.6,6.1c1.7,1.5,3,3.3,3.8,5.4"
          />
        </g>
        <g id="Devices">
          <polygon
            className="st7"
            fill={theme.imageClothes}
            points="491.7,163.2 472.7,242.8 478,242.8 496.8,163.2 	"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M484.4,215.6c-0.3,1.5,8.6,44.9,8.6,44.9h-4.3l-6.8-34.4L484.4,215.6z"
          />
          <rect
            x="458.6"
            y="317.9"
            className="st8"
            fill={theme.accentColor[0]}
            width="89.2"
            height="94.6"
          />
          <rect
            x="547.8"
            y="331.7"
            className="st7"
            fill={theme.imageClothes}
            width="4.4"
            height="4.4"
          />
          <rect
            x="547.8"
            y="345.6"
            className="st7"
            fill={theme.imageClothes}
            width="4.4"
            height="4.4"
          />
          <rect
            x="547.8"
            y="359.6"
            className="st7"
            fill={theme.imageClothes}
            width="4.4"
            height="4.4"
          />
          <rect
            x="547.8"
            y="373.5"
            className="st7"
            fill={theme.imageClothes}
            width="4.4"
            height="4.4"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M552.4,360.8c0.4-0.1,0.9-0.2,1.3-0.3c1.2-0.2,2.5-0.4,3.8-0.4c1.9,0,3.8,0.5,5.4,1.4c2.1,1.3,3.2,3.6,3,6
		c-0.1,1.2-0.5,2.4-1.1,3.4c-0.6,1-1.4,1.8-2.3,2.4c-1.5,1.1-3.3,1.8-5.2,2.1c-1.2,0.2-2.5,0.2-3.8,0.1c-0.5,0-0.9-0.1-1.4-0.2
		c0.5,0,0.9,0,1.4,0c1.2,0,2.5-0.1,3.7-0.3c1.8-0.3,3.5-1,5-2.1c1.8-1.3,3-3.3,3.2-5.5c0.2-2.2-0.8-4.4-2.8-5.6
		c-1.6-1-3.3-1.5-5.2-1.5c-1.2,0-2.5,0-3.7,0.2C553.3,360.8,552.8,360.9,552.4,360.8z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M551.3,347c0.1-0.1,0.3-0.2,0.4-0.2c0.4-0.2,0.9-0.4,1.3-0.5c1.7-0.5,3.4-0.6,5.1-0.3c0.6,0.1,1.1,0.3,1.6,0.6
		c0.6,0.4,1,0.9,1.1,1.6c0.5,2.2-0.7,4.5-2.8,5.4c-0.8,0.3-1.7,0.3-2.4-0.1c-0.8-0.4-1.3-1.2-1.4-2.1c0-0.9,0.6-1.8,1.4-2.2
		c0.8-0.4,1.7-0.5,2.5-0.3c0.8,0.2,1.6,0.5,2.2,1.1c1.2,1,2,2.4,2.2,4c0.1,1.4-0.3,2.9-1.1,4c-0.7,1-1.7,1.8-2.7,2.3
		c-1.6,0.8-3.3,1.2-5,1.3c-0.6,0-1.1,0.1-1.4,0.1c-0.2,0-0.3,0-0.5,0c0,0,0.7-0.1,1.9-0.2c1.7-0.2,3.3-0.7,4.8-1.4
		c1-0.6,1.9-1.3,2.6-2.2c0.8-1,1.1-2.4,1-3.6c-0.2-1.4-0.9-2.7-2.1-3.6c-0.6-0.5-1.3-0.8-2-1c-0.7-0.2-1.5-0.1-2.2,0.2
		c-0.7,0.3-1.1,1-1.1,1.7c0.1,0.7,0.5,1.3,1.1,1.6c0.6,0.3,1.3,0.4,2,0.1c0.6-0.2,1.2-0.7,1.7-1.2c0.9-1,1.3-2.3,1-3.6
		c-0.4-1.1-1.3-1.9-2.5-2c-1.7-0.4-3.4-0.3-5,0.1C551.9,346.7,551.3,347.1,551.3,347z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M551.3,333.4c0.3-0.1,0.7-0.2,1-0.2c0.9-0.1,1.8,0,2.7,0.3c1.3,0.4,2.4,1.2,3.3,2.2c1.1,1.3,1.7,2.9,1.7,4.6
		c0.1,1.7-0.4,3.3-1.4,4.7c-0.8,1.1-1.9,1.9-3.2,2.4c-0.8,0.4-1.7,0.5-2.6,0.5c-0.3,0-0.7,0-1-0.1c1.2,0,2.4-0.3,3.5-0.8
		c1.2-0.5,2.2-1.4,3-2.4c1.8-2.6,1.7-6.2-0.3-8.7c-0.8-1-1.9-1.7-3.1-2.2C553.7,333.6,552.5,333.4,551.3,333.4z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M485.1,267.7c0.3,0.6,0.6,1.2,0.8,1.8c0.5,1.8,0.9,3.6,1.2,5.4c0.4,2.4,0.7,5.3,1,8.6s0.6,7.2,1.1,11.5
		c0.1,1,0.3,2.1,0.5,3.2c0.2,1.1,0.5,2.2,1,3.2c0.6,1,1.3,1.9,2.2,2.7c2.7,2.6,6.3,4.3,10.1,4.7c2.7,0.3,5.4-0.2,7.9-1.4
		c2.6-1.3,4.4-3.6,5.1-6.4c0.3-1.4,0.2-2.9-0.3-4.2c-0.6-1.4-1.5-2.5-2.8-3.4c-1.3-0.8-2.7-1.3-4.2-1.4c-1.5-0.1-3,0.4-4.3,1.2
		c-0.6,0.4-1.1,1-1.5,1.7c-0.3,0.7-0.4,1.4-0.3,2.2c0.4,1.5,1.4,2.8,2.8,3.5c1.4,0.7,3,1.1,4.6,1.3c1.6,0.2,3.2,0.3,4.7,0.3
		c3.1,0,6.2-0.2,9.3-0.5c6.1-0.7,12-1.7,17.6-1.7s11.1,0.7,15.7,3c2.2,1.1,4.2,2.5,5.8,4.4c1.5,1.7,2.5,3.8,3,6
		c0.8,3.8,0.2,7.8-1.8,11.2c-1.5,2.5-3.5,4.7-5.9,6.3c-1.5,1-3.2,1.9-4.9,2.5c-0.6,0.2-1.2,0.4-1.8,0.5l0.5-0.2
		c0.3-0.1,0.8-0.3,1.3-0.5c1.7-0.7,3.3-1.5,4.8-2.6c2.4-1.6,4.4-3.8,5.8-6.3c1.8-3.4,2.4-7.3,1.6-11c-0.5-2.2-1.5-4.2-3-5.8
		c-1.6-1.8-3.6-3.2-5.7-4.2c-4.5-2.2-9.9-3-15.5-2.9c-5.6,0.1-11.5,1-17.6,1.7c-3.1,0.4-6.2,0.6-9.4,0.5c-1.6,0-3.2-0.1-4.8-0.3
		c-1.6-0.1-3.3-0.6-4.7-1.3c-1.5-0.8-2.6-2.2-3-3.9c-0.2-0.8,0-1.7,0.3-2.5c0.4-0.8,0.9-1.4,1.6-1.9c1.3-1,3-1.4,4.6-1.4
		c1.6,0.1,3.2,0.6,4.5,1.5c1.3,0.9,2.3,2.1,3,3.6c0.6,1.5,0.7,3,0.3,4.5c-0.7,2.9-2.7,5.4-5.4,6.7c-2.5,1.2-5.4,1.7-8.1,1.4
		c-2.6-0.3-5.1-1.1-7.4-2.5c-1.1-0.7-2.1-1.4-3-2.3c-0.9-0.8-1.7-1.8-2.3-2.8c-0.5-1.1-0.8-2.2-1-3.3c-0.2-1.1-0.4-2.2-0.5-3.2
		c-0.5-4.2-0.8-8.1-1.1-11.5s-0.6-6.3-0.9-8.6c-0.2-1.8-0.6-3.6-1.1-5.4c-0.1-0.5-0.3-0.9-0.5-1.4
		C485.2,268,485.1,267.8,485.1,267.7z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M542.8,408.6c0,0,0-0.1,0-0.4s0-0.7,0-1.2c0-1.1,0-2.6,0-4.7c0-4.1,0-10.1-0.1-17.7c0-15.2-0.1-36.9-0.1-62.9
		l0.2,0.2h-80.6l0,0l0.3-0.3c0,32,0,61.8,0,86.9l-0.2-0.2l58.4,0.1l16.4,0.1h4.3L542.8,408.6l-1.4-0.1l-4.4,0.1l-16.3,0.1l-58.6,0.1
		h-0.2v-0.2c0-25.1,0-55,0-86.9v-0.3h0.3h80.6h0.2v0.2c0,26-0.1,47.8-0.1,63c0,7.6,0,13.6-0.1,17.7c0,2,0,3.6,0,4.6
		c0,0.5,0,0.9,0,1.2S542.8,408.6,542.8,408.6z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M520,332.3c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.1-0.5-0.4s0.1-0.4,0.4-0.5c0,0,0.1,0,0.1,0
		C519.8,331.9,520,332.1,520,332.3z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M522.3,332.3c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.1-0.5-0.4s0.1-0.4,0.4-0.5c0,0,0.1,0,0.1,0
		C522.1,331.9,522.3,332.1,522.3,332.3z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M524.6,332.3c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.1-0.5-0.4s0.1-0.4,0.4-0.5c0,0,0.1,0,0.1,0
		C524.4,331.9,524.6,332.1,524.6,332.3z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M526.9,332.3c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0
		C526.7,331.9,526.9,332.1,526.9,332.3z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M529.2,332.3c0,0.2-0.2,0.4-0.4,0.4l0,0c-0.2,0-0.4-0.3-0.4-0.5c0-0.2,0.2-0.3,0.4-0.4
		C529,331.9,529.2,332.1,529.2,332.3z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M531.4,332.3c0,0.2-0.2,0.4-0.4,0.4h0c-0.2,0-0.4-0.3-0.4-0.5c0-0.2,0.2-0.3,0.4-0.4
		C531.2,331.9,531.4,332.1,531.4,332.3z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M533.7,332.3c0,0.2-0.2,0.4-0.4,0.4l0,0c-0.2,0-0.4-0.3-0.4-0.5c0-0.2,0.2-0.3,0.4-0.4
		C533.5,331.9,533.7,332.1,533.7,332.3z"
          />
          <circle className="st7" fill={theme.imageClothes} cx="532.3" cy="333.9" r="0.4" />
          <circle className="st7" fill={theme.imageClothes} cx="529.9" cy="333.9" r="0.4" />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M528,333.9c0,0.2-0.2,0.4-0.4,0.4l0,0c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4l0,0
		C527.8,333.4,528,333.6,528,333.9C528,333.9,528,333.9,528,333.9z"
          />
          <circle className="st7" fill={theme.imageClothes} cx="525.3" cy="333.9" r="0.4" />
          <circle className="st7" fill={theme.imageClothes} cx="522.9" cy="333.9" r="0.4" />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M521,333.9c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0
		C520.8,333.4,521,333.6,521,333.9L521,333.9z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M520,335.6c0,0.2-0.2,0.4-0.4,0.4l0,0c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4l0,0
		C519.8,335.2,520,335.4,520,335.6C520,335.6,520,335.6,520,335.6z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M522.3,335.6c0,0.2-0.2,0.4-0.4,0.4l0,0c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4l0,0
		C522.1,335.2,522.3,335.4,522.3,335.6C522.3,335.6,522.3,335.6,522.3,335.6z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M524.6,335.6c0,0.2-0.2,0.4-0.4,0.4l0,0c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4h0
		C524.4,335.2,524.6,335.4,524.6,335.6C524.6,335.6,524.6,335.6,524.6,335.6z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M526.9,335.6c0,0.2-0.3,0.4-0.5,0.4c-0.2,0-0.3-0.2-0.4-0.4c0-0.2,0.1-0.4,0.4-0.5s0.4,0.1,0.5,0.4
		C526.9,335.5,526.9,335.5,526.9,335.6z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M529.2,335.6c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4
		c0,0,0,0,0,0C529,335.2,529.2,335.4,529.2,335.6L529.2,335.6z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M531.4,335.6c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4
		c0,0,0,0,0,0C531.2,335.2,531.4,335.4,531.4,335.6L531.4,335.6z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M533.7,335.6c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4
		c0,0,0,0,0,0C533.5,335.2,533.7,335.4,533.7,335.6L533.7,335.6z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M532.7,337.1c0,0.2-0.2,0.4-0.4,0.4l0,0c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4l0,0
		C532.5,336.7,532.7,336.9,532.7,337.1C532.7,337.1,532.7,337.1,532.7,337.1z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M530.3,337.1c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4v0c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0
		C530.1,336.7,530.3,336.9,530.3,337.1L530.3,337.1z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M528,337.1c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4v0c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0
		C527.8,336.7,528,336.9,528,337.1L528,337.1z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M525.7,337.1c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4v0c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0
		C525.5,336.7,525.7,336.9,525.7,337.1L525.7,337.1z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M523.3,337.1c0,0.2-0.1,0.4-0.4,0.5s-0.4-0.1-0.5-0.4c0,0,0-0.1,0-0.1c0-0.2,0.3-0.4,0.5-0.4
		C523.2,336.8,523.3,336.9,523.3,337.1z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M521,337.1c0,0.2-0.2,0.4-0.4,0.4h0c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4l0,0
		C520.8,336.7,521,336.9,521,337.1C521,337.1,521,337.1,521,337.1z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M520,338.9c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4v0c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0
		C519.8,338.4,520,338.6,520,338.9L520,338.9z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M522.3,338.9c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4v0c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0
		C522.1,338.4,522.3,338.6,522.3,338.9L522.3,338.9z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M524.6,338.9c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.2-0.4-0.4v0c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0
		C524.4,338.4,524.6,338.6,524.6,338.9L524.6,338.9z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M526.9,338.9c0,0.2-0.1,0.4-0.4,0.5s-0.4-0.1-0.5-0.4c0,0,0-0.1,0-0.1c0-0.2,0.3-0.4,0.5-0.4
		C526.7,338.5,526.8,338.7,526.9,338.9z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M529.2,338.9c0,0.2-0.2,0.4-0.4,0.4l0,0c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4l0,0
		C529,338.4,529.2,338.6,529.2,338.9C529.2,338.8,529.2,338.8,529.2,338.9z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M531.4,338.9c0,0.2-0.2,0.4-0.4,0.4h0c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4l0,0
		C531.2,338.4,531.4,338.6,531.4,338.9C531.4,338.8,531.4,338.8,531.4,338.9z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M533.7,338.9c0,0.2-0.2,0.4-0.4,0.4l0,0c-0.2,0-0.4-0.2-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4l0,0
		C533.5,338.4,533.7,338.6,533.7,338.9C533.7,338.8,533.7,338.8,533.7,338.9z"
          />
          <circle className="st7" fill={theme.imageClothes} cx="532.3" cy="340.4" r="0.4" />
          <circle className="st7" fill={theme.imageClothes} cx="529.9" cy="340.4" r="0.4" />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M528,340.4c0,0.2-0.2,0.4-0.4,0.4l0,0c-0.2,0-0.4-0.1-0.5-0.4s0.1-0.4,0.4-0.5c0,0,0.1,0,0.1,0
		C527.8,340,528,340.2,528,340.4C528,340.4,528,340.4,528,340.4z"
          />
          <circle className="st7" fill={theme.imageClothes} cx="525.3" cy="340.4" r="0.4" />
          <circle className="st7" fill={theme.imageClothes} cx="522.9" cy="340.4" r="0.4" />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M521,340.4c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.3-0.4-0.5c0-0.2,0.2-0.3,0.4-0.4
		C520.8,340,521,340.2,521,340.4z"
          />
          <path
            className="st4"
            d="M488.5,238.9c0.6,0,1.1,0.1,1.6,0.3c1.5,0.5,2.9,1.4,3.9,2.6c1.6,1.9,2.8,4.2,3.5,6.6c1,3.2,1.7,6.4,2.2,9.7
		c1.1,8.5,1.3,17.2,0.6,25.8c-0.1,2.5-0.9,5-2.2,7.1c-0.7,1.1-1.7,2-2.8,2.7c-1.2,0.7-2.5,1.1-3.9,0.9c-1.4-0.1-2.7-0.7-3.7-1.7
		c-0.5-0.5-0.9-1.1-1.1-1.8c-0.2-0.7-0.2-1.4,0-2.1c0.4-1.4,1.4-2.6,2.8-3.1c0.7-0.3,1.5-0.3,2.2,0c0.7,0.3,1.3,0.7,1.8,1.3
		c0.9,1.2,1.2,2.7,1,4.1c-0.2,1.4-0.7,2.7-1.5,3.9c-4.1,7.2-13.2,9.9-20.5,5.9c-2.1-1.2-3.9-2.7-5.4-4.6c-1.4-1.8-2.5-3.7-3.3-5.8
		c-1.3-3.8-2.1-7.8-2.2-11.8c-0.2-3.7,0-7-0.4-9.9c-0.2-1.3-0.5-2.6-0.9-3.9c-0.4-1.1-1-2-1.7-2.9c-1-1.2-2.2-2.2-3.7-2.8
		c-0.5-0.2-1.1-0.3-1.6-0.4c0.6,0,1.1,0.1,1.6,0.3c1.5,0.5,2.8,1.5,3.8,2.7c0.7,0.9,1.3,1.9,1.8,3c0.5,1.3,0.8,2.6,1,4
		c0.4,2.9,0.2,6.2,0.4,9.9c0.1,4,0.9,7.9,2.2,11.7c0.8,2.1,1.9,4,3.2,5.7c1.4,1.8,3.2,3.4,5.3,4.5c7.1,3.8,15.9,1.2,19.8-5.8
		c0.7-1.2,1.2-2.4,1.4-3.8c0.2-1.3-0.1-2.7-0.9-3.8c-0.4-0.5-0.9-0.9-1.5-1.2c-0.6-0.2-1.3-0.2-1.9,0c-1.2,0.5-2.1,1.5-2.5,2.8
		c-0.3,1.3,0.1,2.6,1,3.5c0.9,0.9,2.1,1.5,3.4,1.6c1.3,0.1,2.5-0.2,3.6-0.9c1.1-0.7,2-1.5,2.7-2.6c1.3-2.1,2-4.5,2.2-6.9
		c0.7-8.5,0.5-17.1-0.5-25.6c-0.5-3.3-1.2-6.5-2.1-9.6c-0.6-2.4-1.8-4.6-3.4-6.5c-1-1.2-2.3-2.1-3.8-2.6
		C489.6,239.2,489.1,239,488.5,238.9z"
          />
          <rect x="447.4" y="253.4" className="st4" width="33.2" height="6.3" />
          <rect
            x="197.5"
            y="318.8"
            className="st7"
            fill={theme.imageClothes}
            width="43.3"
            height="93.3"
          />
          <path
            className="st9"
            d="M237.1,402.2c0,0,0-0.1,0-0.4s0-0.7,0-1.2c0-1,0-2.5,0-4.5c0-3.9,0-9.5-0.1-16.7c0-14.2-0.1-34.2-0.1-57.5
		l0.2,0.2h-36.2l0,0l0.3-0.3c0,31.2,0,59.5-0.1,80.2l-0.2-0.2l26.5,0.1l7.2,0h1.9C237,402.2,237.2,402.2,237.1,402.2l-0.5-0.1h-1.9
		h-7.2l-26.6,0.1h-0.2v-0.2c0-20.8,0-49.1-0.1-80.2v-0.3h36.8v0.2c0,23.4-0.1,43.4-0.1,57.7c0,7.1,0,12.7-0.1,16.6
		c0,1.9,0,3.4,0,4.4c0,0.5,0,0.9,0,1.1S237.1,402.2,237.1,402.2z"
          />
          <path
            className="st9"
            d="M234.9,328.8c0,0,0-0.4,0-1s0-1.6-0.1-2.7l0.1,0.1c-5.6,0.1-17.6,0.1-31.5,0.1l0,0l0.3-0.3l0,0v1.9
		c0,0.6,0,1.2,0,1.8l-0.2-0.3c8.8,0,16.7,0.1,22.3,0.1l6.7,0.1h1.8c0.2,0,0.4,0,0.7,0c-0.2,0-0.4,0-0.6,0h-1.8l-6.6,0.1
		c-5.7,0.1-13.6,0.1-22.5,0.1h-0.3v-3.9l0,0l0.3-0.3l0,0c13.9,0,25.9,0.1,31.5,0.1h0v0.1c0,1.2,0,2.1-0.1,2.8
		C235,328.1,234.9,328.4,234.9,328.8z"
          />
          <path
            className="st9"
            d="M206.5,331.4c0,0.1-0.6,0.3-1.4,0.3c-0.8,0-1.5-0.1-1.5-0.3s0.6-0.3,1.5-0.3S206.5,331.3,206.5,331.4z"
          />
          <path
            className="st9"
            d="M234.1,336.3c0,0.1-6.7,0.3-15,0.3c-8.3,0-15-0.1-15-0.3s6.7-0.3,15-0.3S234.1,336.1,234.1,336.3z"
          />
          <path
            className="st9"
            d="M234.2,342.1c0,0.1-6.6,0.3-14.7,0.3c-8.1,0-14.7-0.1-14.7-0.3s6.6-0.3,14.7-0.3S234.2,341.9,234.2,342.1z"
          />
          <circle className="st8" fill={theme.accentColor[0]} cx="219.1" cy="355.7" r="2.4" />
          <path
            className="st9"
            d="M212.3,355.6c-1,0.3-2.1,0.3-3.2,0.3c-1.1,0.1-2.1,0-3.1-0.3c1-0.3,2.1-0.3,3.2-0.3
		C210.2,355.2,211.3,355.3,212.3,355.6z"
          />
          <path
            className="st9"
            d="M231.7,354.9c-1,0.3-2,0.3-3,0.3c-1,0.1-2,0-3-0.3c1-0.3,2-0.3,3-0.3C229.7,354.6,230.7,354.7,231.7,354.9z"
          />
          <path
            className="st7"
            fill={theme.imageClothes}
            d="M199,365.6c-0.5-0.1-1.1-0.2-1.6-0.3c-1.5-0.4-3-1.1-4.3-2c-2.1-1.4-3.8-3.3-5.2-5.4c-1.7-2.8-3-5.9-3.8-9.2
		c-1-3.9-1.4-7.9-1.1-11.9c0.3-4.7,1.8-9.1,4.6-12.9c1.5-2,3.3-3.8,5.4-5.2c1.1-0.7,2.3-1.3,3.5-1.7c1.3-0.4,2.5-0.7,3.9-0.9
		c2.6-0.4,5.3-0.3,8-0.5c2.7-0.1,5.4-0.7,7.9-1.8c2.5-1.1,4.3-3.4,4.9-6c1-4.5-1.8-9.1-6.3-10.1c-0.7-0.2-1.4-0.2-2.1-0.2
		c-1.2,0.1-2.4,0.5-3.3,1.2c-0.9,0.7-1.4,1.8-1.4,3c0.3,2.3,2.1,4.1,4.5,4.3c2.2,0,4.3-0.9,5.7-2.6c1.3-1.6,2.3-3.4,2.8-5.4
		c0.5-1.8,0.9-3.7,1.1-5.6c0.7-5.7,0.9-11.5,0.5-17.3c-0.1-2-0.2-3.6-0.2-4.7c0-0.5,0-0.9-0.1-1.2c0-0.1,0-0.3,0-0.4
		c0,0.1,0.1,0.3,0.1,0.4c0,0.3,0.1,0.7,0.1,1.2c0.1,1.1,0.2,2.7,0.3,4.7c0.4,5.8,0.3,11.6-0.4,17.4c-0.3,1.9-0.6,3.8-1.1,5.7
		c-0.5,2.1-1.5,4-2.8,5.6c-1.5,1.8-3.7,2.8-6.1,2.7c-2.6-0.2-4.6-2.2-4.9-4.7c-0.1-1.3,0.5-2.6,1.6-3.4c1-0.8,2.3-1.3,3.6-1.4
		c5-0.1,9,3.9,9.1,8.9c0,2.1-0.7,4.1-2,5.8c-0.9,1.1-2.1,2-3.4,2.6c-2.5,1.2-5.3,1.8-8.1,1.9c-2.7,0.2-5.4,0.1-8,0.5
		c-1.3,0.2-2.5,0.5-3.8,0.9c-1.2,0.4-2.3,1-3.4,1.7c-2.1,1.3-3.9,3-5.3,5c-2.7,3.7-4.2,8.1-4.5,12.7c-0.3,4,0.1,8,1.1,11.8
		c0.7,3.2,2,6.3,3.7,9.1c1.3,2.1,3,3.9,5,5.4c1.3,0.9,2.7,1.6,4.2,2.1c0.5,0.1,0.9,0.2,1.2,0.3C198.7,365.5,198.9,365.5,199,365.6z"
          />
          <rect
            x="184.3"
            y="174.1"
            className="st7"
            fill={theme.imageClothes}
            width="102.6"
            height="70.5"
          />
          <rect
            x="227.6"
            y="234.9"
            className="st7"
            fill={theme.imageClothes}
            width="14"
            height="26.6"
          />
        </g>
        <g id="Desk">
          <polygon
            className="st7"
            fill={theme.imageClothes}
            points="194.5,260.5 194.5,270.1 247.4,270.1 247.4,412.5 252.3,412.5 252.3,270.1 473.4,271.2 473.4,412.5 
		478.1,412.5 478.1,270.9 512.3,271.2 512.3,259.7 	"
          />
          <polygon
            className="st7"
            fill={theme.imageClothes}
            points="228.3,268.2 249.2,283.2 247.4,285 226.4,269.1 	"
          />
          <polygon
            className="st7"
            fill={theme.imageClothes}
            points="497.8,269.6 473.6,286.9 475.4,288.6 499.8,270.5 	"
          />
          <rect
            x="271.5"
            y="257"
            className="st7"
            fill={theme.imageClothes}
            width="54.7"
            height="4"
          />
        </g>
      </svg>
    </div>
  );
}
Codering.propTypes = {
  theme: PropTypes.object
};
